import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  useCallback,
  useMemo,
} from "react"; // Add useRef here
import { useSelector, useDispatch } from "react-redux";
import {
  Box,
  Typography,
  Button,
  CircularProgress,
  Card,
  CardContent,
  Grid,
  Divider,
  IconButton,
  Tooltip,
  FormControlLabel,
  Collapse,
  List,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Checkbox,
  CardHeader,
  TextField,
  InputAdornment,
} from "@mui/material";
import UpgradeIcon from "@mui/icons-material/Upgrade";
import "./overviewconfig.css";
// Import custom components
import CustomButton from "../CommonComponents/CustomButton";
import CustomCancelButton from "../CommonComponents/CustomCancelButton";
import CustomTextFieldWithErrorProps from "../CommonComponents/CustomTextFieldWithErrorProps";
import CustomTextFieldNew from "../CommonComponents/CustomTextFieldNew";
import CustomToast from "../CommonComponents/CustomToast";
import CustomDialogBox from "../CommonComponents/CustomDialogBox";
import CustomDropDown from "../CommonComponents/CustomDropDown";
import CustomCheckbox from "../CommonComponents/CustomCheckbox";
import CustomUploadButton from "../CommonComponents/CustomUploadButton";
import ParameterTable from "../Dashboards/Graphs/Table/DragDropTable";
// Logo Selection Section Component (for parameter logo)
import DeleteIcon from "@mui/icons-material/Delete";

// Import icons
import LK_Add from "../../images/LK_Add";
import LK_Delete from "../../images/LK_Delete";
import LK_Search from "../../images/LK_Search";
import LK_Close from "../../images/LK_Close";
import LK_CheckboxChecked from "../../images/LK_CheckboxChecked";
import LK_CheckboxUnchecked from "../../images/LK_CheckboxUnchecked";
import EditIcon from "@mui/icons-material/Edit";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import ExpandLessOutlinedIcon from "@mui/icons-material/ExpandLessOutlined";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { CloseOutlined } from "@ant-design/icons";
import { Input, Tree, Radio } from "antd";
import AddIcon from "@mui/icons-material/Add";
import {
  updateoverviewbarCollection,
  updateoverviewbarConfigCollection,
} from "../../store/cofig_data";

// Import context
import { ThemeContext } from "../Homepage";

// Import API function
import {
  getdevicetags,
  getdevicetags1,
  postoverviewconfig,
  getOverviewConfig,
  getProjectName,
} from "../../Restclient/datacollection";

// Utility functions for tag selection
function not(a, b) {
  return a.filter((value) => !b.includes(value));
}

function intersection(a, b) {
  return a.filter((value) => b.includes(value));
}

function union(a, b) {
  return [...a, ...not(b, a)];
}
const MAX_PARAMETERS = 8;

/**
 * OverviewConfig Component
 *
 * REFACTORING NOTES:
 * - Replaced single currentParameter state object with individual state variables
 * - This prevents unnecessary re-renders by allowing granular state updates
 * - Each property of currentParameter now has its own state setter
 * - Helper functions getCurrentParameterObject(), resetParameterStates(), and loadParameterFromObject()
 *   manage the conversion between individual states and the parameter object structure
 */
const OverviewConfig = () => {
  // Get theme context
  const { theme } = useContext(ThemeContext) || { theme: "light" };

  // Redux state
  const userDetails =
    useSelector((state) => state.logindata?.userdetails) || {};
  const projectData =
    useSelector((state) => state.logindata?.projectdata) || {};
  const overviewbarConfigCollection =
    useSelector((state) => state.configdata?.overviewbarConfigCollection) || [];
  const projectId = useSelector(
    (state) => state.mainpagedata.selectedprojectname,
  );
  const tagdetailsobject = useSelector(
    (state) => state.mainpagedata.tagdetailsobject,
  );
  const devicedetailsobject = useSelector(
    (state) => state.mainpagedata.devicedetailsobject,
  );
  const dispatch = useDispatch();
  const projectdata = useSelector((state) => state.logindata.projectdata);
  const selecteddates_dashboard = useSelector(
    (state) => state.mainpagedata.selecteddates_dashboard,
  );
  const [currentProject, setCurrentProject] = useState("");
  const [createdSucess, setCreatedSuccess] = useState(false);
  const [notCreatedSuccess, setNotCreatedSuccess] = useState(false);
  const [createdSucessMsg, setCreatedSuccessMsg] = useState("");
  const [notCreatedSuccessMsg, setNotCreatedSuccessMsg] = useState("");
  const projectname = useSelector(
    (state) => state.mainpagedata.selectedprojectname,
  );
  const dateselected = useSelector((state) => state.mainpagedata.selecteddate);
  //const organizationData = useSelector((state) => state.logindata.organisationdata);
  //console.log("eeeee",projectdata);
  //console.log("ffff",organizationData);
  // Add these selectors to get organization and project data
  const organizationData = useSelector(
    (state) => state.logindata.organisationdata,
  );
  const projectDataArray =
    useSelector((state) => state.logindata?.projectdata) || [];
  const liveData = useSelector((state) => state.logindata?.livedata);
  // Add this in your component to debug the data structure:
  // useEffect(() => {
  //   console.log('Organization Data:', organizationData);
  //   console.log('Project Data Array:', projectDataArray);
  //   console.log('Live Data:', liveData);
  // }, [organizationData, projectDataArray, liveData]);
  const [parameter, setParameter] = useState({
    plantDetails: {
      clientType: "organization", // 'organization' or 'custom'
      clientValue: "",
      projectType: "project", // 'project' or 'custom'
      projectValue: "",
      customFieldType: "projectDetail", // 'projectDetail' or 'custom'
      selectedProjectDetail: "Country",
      customFieldName: "",
      customFieldValue: "",
      plantIconPath: "",
    },
  });

  // State for main UI
  const [openForm, setOpenForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [parameters, setParameters] = useState([]);
  // Decoupled currentParameter states
  const [paramId, setParamId] = useState("");
  const [paramName, setParamName] = useState("");
  const [parameterType, setParameterType] = useState("tag");
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [targetYearlyBaseline, setTargetYearlyBaseline] = useState(false);
  const [targetTarget, setTargetTarget] = useState(false);
  const [targetManualValue, setTargetManualValue] = useState("");
  const [targetManualUnit, setTargetManualUnit] = useState("");
  const [aggregation, setAggregation] = useState("Sum");
  const [timePeriod, setTimePeriod] = useState("Today");
  const [unitSelection, setUnitSelection] = useState("Unit");
  const [iconPath, setIconPath] = useState("");
  const [iconBase64, setIconBase64] = useState("");
  const [iconHeight, setIconHeight] = useState("");
  const [iconWidth, setIconWidth] = useState("");
  const [showInCollapsedMode, setShowInCollapsedMode] = useState(false);
  const [showAsCriticalParameter, setShowAsCriticalParameter] = useState(false);
  const [displayOrder, setDisplayOrder] = useState(0);
  const [isDisplayed, setIsDisplayed] = useState(true);
  const [plantClientType, setPlantClientType] = useState("organization");
  const [plantClientValue, setPlantClientValue] = useState("");
  const [plantProjectType, setPlantProjectType] = useState("project");
  const [plantProjectValue, setPlantProjectValue] = useState("");
  const [plantSelectedProjectDetail, setPlantSelectedProjectDetail] =
    useState("Country");
  const [plantCustomFieldType, setPlantCustomFieldType] =
    useState("projectDetail");
  const [
    plantSelectedAdditionalFieldDetail,
    setPlantSelectedAdditionalFieldDetail,
  ] = useState("Country");
  const [plantCustomFieldName, setPlantCustomFieldName] = useState("");
  const [plantCustomFieldValue, setPlantCustomFieldValue] = useState("");
  const [plantIconPath, setPlantIconPath] = useState("");
  const [plantIconBase64, setPlantIconBase64] = useState("");
  const [plantIconHeight, setPlantIconHeight] = useState("");
  const [plantIconWidth, setPlantIconWidth] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredParameters, setFilteredParameters] = useState([]);
  const [deleteMode, setDeleteMode] = useState(false);
  const [deleteParameterArr, setDeleteParameterArr] = useState([]);
  const [exportMode, setExportMode] = useState(false); // Add this
  const [exportParameterArr, setExportParameterArr] = useState([]); // Add this
  const [lockedAggregation, setLockedAggregation] = useState(null);

  // New state for device and tag selection
  const [assetData, setAssetData] = useState(null);
  const [assetIsLoading, setAssetIsLoading] = useState(false);
  const [expandedDevices, setExpandedDevices] = useState({});
  const [selectedDeviceId, setSelectedDeviceId] = useState("");
  const [selectedTagId, setSelectedTagId] = useState("");
  const [selectedTagType, setSelectedTagType] = useState(null);
  const getTagType = useCallback(
    (value) => (value.includes("LIVE") ? "live" : "historical"),
    [],
  );
  // New state for Display popup
  const [openDisplayPopup, setOpenDisplayPopup] = useState(false);
  const [displayParameters, setDisplayParameters] = useState([]);
  const [selectedDisplayParams, setSelectedDisplayParams] = useState([]);

  // State for Tag Selection Popup
  const [openTagSelectionPopup, setOpenTagSelectionPopup] = useState(false);
  // Add this new state for Live/Historical selection
  const [dataMode, setDataMode] = useState("live"); // "live" or "historical"

  // Add this with other section expansion states
  const [plantDetails, setPlantDetails] = useState(1);

  // Add these new state variables for logo functionality
  const [imageheight, setImageheight] = useState(100);
  const [backgroundimg, setBackgroundimg] = useState("");
  const [imagewidth, setImagewidth] = useState(100);
  const inputFile = useRef(null);

  // Add logo error states to your existing errors state
  const [logoErrors, setLogoErrors] = useState({
    logoHeight: "",
    logoWidth: "",
  });

  // Add these state variables for local input values
  const [localHeight, setLocalHeight] = useState("");
  const [localWidth, setLocalWidth] = useState("");

  // Add this useEffect to sync local state with icon data
  useEffect(() => {
    setLocalHeight(iconHeight || "");
    setLocalWidth(iconWidth || "");
  }, [iconHeight, iconWidth]);

  // Update the handleLogoDimensionChange function
  const handleLogoDimensionChange = (field, value) => {
    if (field === "height") {
      setIconHeight(value);
      if (value && !isValidNumber(value, 20, 40)) {
        setLogoErrors((prev) => ({
          ...prev,
          logoHeight: "Height must be between 20 and 40 pixels",
        }));
      } else {
        setLogoErrors((prev) => ({ ...prev, logoHeight: "" }));
      }
    } else if (field === "width") {
      setIconWidth(value);
      if (value && !isValidNumber(value, 20, 40)) {
        setLogoErrors((prev) => ({
          ...prev,
          logoWidth: "Width must be between 20 and 40 pixels",
        }));
      } else {
        setLogoErrors((prev) => ({ ...prev, logoWidth: "" }));
      }
    }

    // Clear logo errors when user types
    if (logoErrors[`logo${field.charAt(0).toUpperCase() + field.slice(1)}`]) {
      setLogoErrors((prev) => ({
        ...prev,
        [`logo${field.charAt(0).toUpperCase() + field.slice(1)}`]: "",
      }));
    }
  };

  // Add these new handler functions for local state
  const handleLocalHeightChange = (value) => {
    setLocalHeight(value);
  };

  const handleLocalWidthChange = (value) => {
    setLocalWidth(value);
  };

  // Update on blur or when user stops typing
  const handleHeightBlur = () => {
    handleLogoDimensionChange("height", localHeight);
  };

  const handleWidthBlur = () => {
    handleLogoDimensionChange("width", localWidth);
  };

  function handleCloseCreateDashboard() {
    setCreatedSuccess(false);
  }

  function handleCloseNotCreateDashboard() {
    setNotCreatedSuccess(false);
  }

  // Add these new state variables for plant icon functionality
  const [plantImageHeight, setPlantImageHeight] = useState(100);
  const [plantBackgroundImg, setPlantBackgroundImg] = useState("");
  const [plantImageWidth, setPlantImageWidth] = useState(100);
  const plantInputFile = useRef(null);

  // Add plant icon local state for better input handling
  const [localPlantHeight, setLocalPlantHeight] = useState("");
  const [localPlantWidth, setLocalPlantWidth] = useState("");

  // Add plant logo error states
  const [plantLogoErrors, setPlantLogoErrors] = useState({
    plantLogoHeight: "",
    plantLogoWidth: "",
  });

  // Tag Selection Popup States
  const [checked, setChecked] = useState([]);
  const [left, setLeft] = useState([]);
  const [right, setRight] = useState([]);
  const [center, setCenter] = useState([
    "Summation",
    "Average",
    "Difference",
    "Start Value",
    "End Value",
    "Minimum",
    "Maximum",
  ]);
  const [disabled, setDisabled] = useState([
    true,
    true,
    true,
    true,
    true,
    true,
    true,
  ]);
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [checkedKeys, setCheckedKeys] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [autoExpandParent, setAutoExpandParent] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [value3, setValue3] = useState("name");
  // Add this new state variable with other state declarations
  const [hasPredefinedTags, setHasPredefinedTags] = useState(false);

  useEffect(() => {
    const hasTargetOrBaseline = right.some(
      (item) =>
        item.includes("TAG_TARGET") || item.includes("TAG_YEARLY_BASELINE"),
    );
    setHasPredefinedTags(hasTargetOrBaseline);

    // If predefined tags are present, automatically switch to live mode
    // but don't disable further selections
    if (hasTargetOrBaseline && dataMode === "historical") {
      setDataMode("live");
    }
  }, [right]);

  // Section expansion states
  const [deviceDetails, setDeviceDetails] = useState(1);
  const [displaySettings, setDisplaySettings] = useState(1);

  // Toast and dialog state
  const [toast, setToast] = useState({
    open: false,
    title: "",
    message: "",
    type: "Info",
  });
  const [openToast, setOpenToast] = useState(false);
  const [showDialogDelete, setShowDialogDelete] = useState(false);
  const [dialogContent, setDialogContent] = useState({
    title: "",
    message: "",
  });
  const [showDialog, setShowDialog] = useState(false);
  const [showExportDialog, setShowExportDialog] = useState(false); // Add this

  // Form validation state
  const [required, setRequired] = useState(false);
  const [saveStatus, setSaveStatus] = useState(0);

  // File upload state
  const [selectedFile, setSelectedFile] = useState(null);

  // Default aggregation options
  const aggregationOptions = ["Sum", "Average", "Min", "Max"];

  // Default time period options
  const timePeriodOptions = [
    "Today",
    "Yesterday",
    "This Week",
    "Last Week",
    "This Month",
    "Last Month",
    "This Year",
    "Last Year",
  ];

  // Default unit options
  const unitOptions = [
    "Milli",
    "Centi",
    "Deci",
    "Unit",
    "Deca",
    "Hecto",
    "Kilo",
    "Mega",
    "Giga",
    "Tera",
  ];

  // Helper function to construct currentParameter from individual states
  const getCurrentParameterObject = useCallback(
    () => ({
      id: paramId,
      name: paramName,
      parameterType: parameterType,
      selectedDevices: selectedDevices,
      selectedTags: selectedTags,
      targetSelection: {
        yearlyBaseline: targetYearlyBaseline,
        target: targetTarget,
        manualValue: targetManualValue,
        manualUnit: targetManualUnit,
      },
      aggregation: aggregation,
      timePeriod: timePeriod,
      unitSelection: unitSelection,
      iconPath: iconPath,
      iconData: {
        base64: iconBase64,
        height: iconHeight,
        width: iconWidth,
      },
      showInCollapsedMode: showInCollapsedMode,
      showAsCriticalParameter: showAsCriticalParameter,
      displayOrder: displayOrder,
      isDisplayed: isDisplayed,
      plantDetails: {
        clientType: plantClientType,
        clientValue: plantClientValue,
        projectType: plantProjectType,
        projectValue: plantProjectValue,
        selectedProjectDetail: plantSelectedProjectDetail,
        customFieldType: plantCustomFieldType,
        selectedAdditionalFieldDetail: plantSelectedAdditionalFieldDetail,
        customFieldName: plantCustomFieldName,
        customFieldValue: plantCustomFieldValue,
        plantIconPath: plantIconPath,
        plantIconData: {
          base64: plantIconBase64,
          height: plantIconHeight,
          width: plantIconWidth,
        },
      },
    }),
    [
      paramId,
      paramName,
      parameterType,
      selectedDevices,
      selectedTags,
      targetYearlyBaseline,
      targetTarget,
      targetManualValue,
      targetManualUnit,
      aggregation,
      timePeriod,
      unitSelection,
      iconPath,
      iconBase64,
      iconHeight,
      iconWidth,
      showInCollapsedMode,
      showAsCriticalParameter,
      displayOrder,
      isDisplayed,
      plantClientType,
      plantClientValue,
      plantProjectType,
      plantProjectValue,
      plantSelectedProjectDetail,
      plantCustomFieldType,
      plantSelectedAdditionalFieldDetail,
      plantCustomFieldName,
      plantCustomFieldValue,
      plantIconPath,
      plantIconBase64,
      plantIconHeight,
      plantIconWidth,
    ],
  );

  // Helper function to reset all parameter states
  const resetParameterStates = useCallback(() => {
    setParamId("");
    setParamName("");
    setParameterType("tag");
    setSelectedDevices([]);
    setSelectedTags([]);
    setTargetYearlyBaseline(false);
    setTargetTarget(false);
    setTargetManualValue("");
    setTargetManualUnit("");
    setAggregation("Sum");
    setTimePeriod("Today");
    setUnitSelection("Unit");
    setIconPath("");
    setIconBase64("");
    setIconHeight("");
    setIconWidth("");
    setShowInCollapsedMode(false);
    setShowAsCriticalParameter(false);
    setDisplayOrder(0);
    setIsDisplayed(true);
    setPlantClientType("organization");
    setPlantClientValue("");
    setPlantProjectType("project");
    setPlantProjectValue("");
    setPlantSelectedProjectDetail("Country");
    setPlantCustomFieldType("projectDetail");
    setPlantSelectedAdditionalFieldDetail("Country");
    setPlantCustomFieldName("");
    setPlantCustomFieldValue("");
    setPlantIconPath("");
    setPlantIconBase64("");
    setPlantIconHeight("");
    setPlantIconWidth("");
  }, []);

  // Helper function to load parameter from object
  const loadParameterFromObject = useCallback((param) => {
    setParamId(param.id || "");
    setParamName(param.name || "");
    setParameterType(param.parameterType || "tag");
    setSelectedDevices(param.selectedDevices || []);
    setSelectedTags(param.selectedTags || []);
    setTargetYearlyBaseline(param.targetSelection?.yearlyBaseline || false);
    setTargetTarget(param.targetSelection?.target || false);
    setTargetManualValue(param.targetSelection?.manualValue || "");
    setTargetManualUnit(param.targetSelection?.manualUnit || "");
    setAggregation(param.aggregation || "Sum");
    setTimePeriod(param.timePeriod || "Today");
    setUnitSelection(param.unitSelection || "Unit");
    setIconPath(param.iconPath || "");
    setIconBase64(param.iconData?.base64 || "");
    setIconHeight(param.iconData?.height || "");
    setIconWidth(param.iconData?.width || "");
    setShowInCollapsedMode(param.showInCollapsedMode || false);
    setShowAsCriticalParameter(param.showAsCriticalParameter || false);
    setDisplayOrder(param.displayOrder !== undefined ? param.displayOrder : 0);
    setIsDisplayed(param.isDisplayed !== undefined ? param.isDisplayed : true);
    setPlantClientType(param.plantDetails?.clientType || "organization");
    setPlantClientValue(param.plantDetails?.clientValue || "");
    setPlantProjectType(param.plantDetails?.projectType || "project");
    setPlantProjectValue(param.plantDetails?.projectValue || "");
    setPlantSelectedProjectDetail(
      param.plantDetails?.selectedProjectDetail || "Country",
    );
    setPlantCustomFieldType(
      param.plantDetails?.customFieldType || "projectDetail",
    );
    setPlantSelectedAdditionalFieldDetail(
      param.plantDetails?.selectedAdditionalFieldDetail || "Country",
    );
    setPlantCustomFieldName(param.plantDetails?.customFieldName || "");
    setPlantCustomFieldValue(param.plantDetails?.customFieldValue || "");
    setPlantIconPath(param.plantDetails?.plantIconPath || "");
    setPlantIconBase64(param.plantDetails?.plantIconData?.base64 || "");
    setPlantIconHeight(param.plantDetails?.plantIconData?.height || "");
    setPlantIconWidth(param.plantDetails?.plantIconData?.width || "");
  }, []);

  const emptyParameter = {
    id: "",
    name: "",
    parameterType: "tag",
    selectedDevices: [],
    selectedTags: [],
    targetSelection: {
      yearlyBaseline: false,
      target: false,
      manualValue: "",
      manualUnit: "",
    },
    aggregation: "Sum",
    timePeriod: "Today",
    unitSelection: "Unit",
    iconPath: "",
    iconData: {
      base64: "",
      height: "",
      width: "",
    },
    showInCollapsedMode: false,
    showAsCriticalParameter: false,
    displayOrder: 0,
    isDisplayed: true,
    plantDetails: {
      clientType: "organization",
      clientValue: "",
      projectType: "project",
      projectValue: "",
      selectedProjectDetail: "Country",
      customFieldType: "projectDetail",
      selectedAdditionalFieldDetail: "Country",
      customFieldName: "",
      customFieldValue: "",
      plantIconPath: "",
      plantIconData: {
        base64: "",
        height: "",
        width: "",
      },
    },
  };
  // Base64 conversion function
  const base64convert = (file, cb) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(reader.result);
    };
    reader.onerror = function (error) {
      console.log("Error reading file:", error);
    };
  };

  // Handle image upload
  const handleImageUpload = (e) => {
    const { files } = e.target;
    if (files && files.length) {
      const file = files[0];
      const filename = file.name;
      const parts = filename.split(".");
      const fileType = parts[parts.length - 1];

      // Validate file type
      if (!["png", "jpg", "jpeg", "gif"].includes(fileType.toLowerCase())) {
        showToast(
          "Error",
          "Invalid file type. Please upload an image file (PNG, JPG, JPEG, GIF).",
          "Error",
        );
        return;
      }

      // Validate image size before converting to base64
      const img = new window.Image();
      img.onload = function () {
        if (img.width > 70 || img.height > 70) {
          showToast(
            "Error",
            "Image size must be 70x70 pixels or below.",
            "Error",
          );
          return;
        }
        base64convert(file, (result) => {
          setBackgroundimg(result);
          setIconBase64(result);
          setIconHeight(img.height.toString());
          setIconWidth(img.width.toString());
          setLocalHeight(img.height.toString());
          setLocalWidth(img.width.toString());
        });
      };
      img.onerror = function () {
        showToast("Error", "Failed to load image for validation.", "Error");
      };
      img.src = URL.createObjectURL(file);
    }
  };

  // Handle logo removal
  const handleRemoveLogo = () => {
    setBackgroundimg("");
    setIconBase64("");
    setIconHeight("");
    setIconWidth("");
    setLocalHeight("");
    setLocalWidth("");
    setLogoErrors({ logoHeight: "", logoWidth: "" });
    if (inputFile.current) inputFile.current.value = "";
  };
  // Handle image upload
  // const handleImageUpload = (e) => {
  //   const { files } = e.target;

  //   if (files && files.length) {
  //     const file = files[0];
  //     const filename = file.name;
  //     const parts = filename.split(".");
  //     const fileType = parts[parts.length - 1];

  //     // Validate file type
  //     if (!["png", "jpg", "jpeg", "gif"].includes(fileType.toLowerCase())) {
  //       showToast('Error', 'Invalid file type. Please upload an image file (PNG, JPG, JPEG, GIF).', 'Error');
  //       return;
  //     }

  //     base64convert(file, (result) => {
  //       setBackgroundimg(result);

  //       // Set default values to 30
  //       setLocalHeight("30");
  //       setLocalWidth("30");

  //       // Update the current parameter
  //       setCurrentParameter(prev => ({
  //         ...prev,
  //         iconData: {
  //           ...prev.iconData,
  //           base64: result,
  //           height: "30",
  //           width: "30"
  //         }
  //       }));
  //     });
  //   }
  // };

  // Handle logo click
  const handleLogoClick = () => {
    if (inputFile && inputFile.current) {
      inputFile.current.value = "";
      inputFile.current.click();
    }
  };

  const LogoSelectionSection = () => {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          flexDirection: "column",
          width: "100%",
        }}
      >
        <Typography
          style={{
            marginBottom: "10px",
            marginTop: "10px",
            fontSize: "16px",
            fontWeight: 400,
            color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
          }}
        >
          Logo
        </Typography>
        <Box style={{ display: "flex", gap: "20px", alignItems: "center" }}>
          <Box
            sx={{
              height: "100px",
              width: "100px",
              border: "2px solid #008CD7",
              borderRadius: "50%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundImage: `url(${backgroundimg})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center center",
              backgroundSize: `${localWidth || iconWidth || imagewidth}px ${localHeight || iconHeight || imageheight}px`,
              cursor: "pointer",
              position: "relative",
            }}
            onClick={handleLogoClick}
          >
            <input
              style={{ display: "none" }}
              ref={inputFile}
              onChange={handleImageUpload}
              type="file"
              accept=".png,.PNG,.jpg,.jpeg,.gif"
              multiple={false}
            />
            {backgroundimg === "" ? (
              <AddIcon
                style={{
                  width: "40px",
                  height: "40px",
                  color: "#008CD7",
                  cursor: "pointer",
                }}
              />
            ) : (
              <>
                <img
                  src={backgroundimg}
                  alt="Logo Preview"
                  style={{
                    width: localWidth || iconWidth || imagewidth,
                    height: localHeight || iconHeight || imageheight,
                    objectFit: "contain",
                    borderRadius: "50%",
                  }}
                />
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRemoveLogo();
                  }}
                  sx={{
                    position: "absolute",
                    top: 2,
                    right: 2,
                    background: "rgba(255,255,255,0.7)",
                    zIndex: 2,
                  }}
                  aria-label="Remove logo"
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </>
            )}
          </Box>
          <Box>
            <Box style={{ display: "flex", flexDirection: "column" }}>
              <TextField
                label="Height"
                variant="standard"
                disabled={true}
                type="number"
                InputProps={{
                  inputProps: { min: 1, max: 70 },
                }}
                sx={{
                  width: "80px",
                  marginBottom: "10px",
                  "& .MuiInputLabel-root": {
                    color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: "var(--PrimaryText)",
                  },
                }}
                value={localHeight}
                onChange={(e) => handleLocalHeightChange(e.target.value)}
                onBlur={handleHeightBlur}
                error={!!logoErrors.logoHeight}
                helperText={logoErrors.logoHeight}
              />
              <TextField
                label="Width"
                variant="standard"
                type="number"
                disabled={true}
                InputProps={{
                  inputProps: { min: 1, max: 70 },
                }}
                sx={{
                  width: "80px",
                  marginBottom: "20px",
                  "& .MuiInputLabel-root": {
                    color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: "var(--PrimaryText)",
                  },
                }}
                value={localWidth}
                onChange={(e) => handleLocalWidthChange(e.target.value)}
                onBlur={handleWidthBlur}
                error={!!logoErrors.logoWidth}
                helperText={logoErrors.logoWidth}
              />
            </Box>
          </Box>
        </Box>
        <Typography
          style={{
            fontSize: "12px",
            color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
            marginTop: "5px",
          }}
        >
          Allowed formats: PNG, JPG, JPEG, GIF (Max Height & Width: 70px)
        </Typography>
      </Box>
    );
  };

  // Handle plant image upload
  const handlePlantImageUpload = (e) => {
    const { files } = e.target;

    if (files && files.length) {
      const file = files[0];
      const filename = file.name;
      const parts = filename.split(".");
      const fileType = parts[parts.length - 1];

      // Validate file type
      if (!["png", "jpg", "jpeg", "gif"].includes(fileType.toLowerCase())) {
        showToast(
          "Error",
          "Invalid file type. Please upload an image file (PNG, JPG, JPEG, GIF).",
          "Error",
        );
        return;
      }

      base64convert(file, (result) => {
        setPlantBackgroundImg(result);
        setPlantIconBase64(result);
      });
    }
  };
  // Handle plant image upload
  // const handlePlantImageUpload = (e) => {
  //   const { files } = e.target;

  //   if (files && files.length) {
  //     const file = files[0];
  //     const filename = file.name;
  //     const parts = filename.split(".");
  //     const fileType = parts[parts.length - 1];

  //     // Validate file type
  //     if (!["png", "jpg", "jpeg", "gif"].includes(fileType.toLowerCase())) {
  //       showToast('Error', 'Invalid file type. Please upload an image file (PNG, JPG, JPEG, GIF).', 'Error');
  //       return;
  //     }

  //     base64convert(file, (result) => {
  //       setPlantBackgroundImg(result);

  //       // Set default values to 30
  //       setLocalPlantHeight("30");
  //       setLocalPlantWidth("30");

  //       // Update the current parameter
  //       setCurrentParameter(prev => ({
  //         ...prev,
  //         plantDetails: {
  //           ...prev.plantDetails,
  //           plantIconData: {
  //             ...prev.plantDetails.plantIconData,
  //             base64: result,
  //             height: "30",
  //             width: "30"
  //           }
  //         }
  //       }));
  //     });
  //   }
  // };

  // Handle plant logo click
  const handlePlantLogoClick = () => {
    if (plantInputFile && plantInputFile.current) {
      plantInputFile.current.value = "";
      plantInputFile.current.click();
    }
  };

  // Handle plant logo dimension changes
  const handlePlantLogoDimensionChange = (field, value) => {
    if (field === "height") {
      setPlantIconHeight(value);
      if (value && !isValidNumber(value, 20, 40)) {
        setPlantLogoErrors((prev) => ({
          ...prev,
          plantLogoHeight: "Height must be between 20 and 40 pixels",
        }));
      } else {
        setPlantLogoErrors((prev) => ({ ...prev, plantLogoHeight: "" }));
        if (value && !isValidNumber(value, 20, 40)) {
          setPlantLogoErrors((prev) => ({
            ...prev,
            plantLogoWidth: "Width must be between 20 and 40 pixels",
          }));
        } else {
          setPlantLogoErrors((prev) => ({ ...prev, plantLogoWidth: "" }));
        }
      }
    } else if (field === "width") {
      setPlantIconWidth(value);
    }

    // Clear plant logo errors when user types
    if (
      plantLogoErrors[
        `plantLogo${field.charAt(0).toUpperCase() + field.slice(1)}`
      ]
    ) {
      setPlantLogoErrors((prev) => ({
        ...prev,
        [`plantLogo${field.charAt(0).toUpperCase() + field.slice(1)}`]: "",
      }));
    }
  };

  // Plant icon local state handlers
  const handleLocalPlantHeightChange = (value) => {
    setLocalPlantHeight(value);
  };

  const handleLocalPlantWidthChange = (value) => {
    setLocalPlantWidth(value);
  };

  // Update on blur
  const handlePlantHeightBlur = () => {
    handlePlantLogoDimensionChange("height", localPlantHeight);
  };

  const handlePlantWidthBlur = () => {
    handlePlantLogoDimensionChange("width", localPlantWidth);
  };

  // Sync plant icon local state with plant icon data
  useEffect(() => {
    setLocalPlantHeight(plantIconHeight || "");
    setLocalPlantWidth(plantIconWidth || "");
  }, [plantIconHeight, plantIconWidth]);

  // useEffect(()=>{

  // },[currentParameter])
  // Plant Icon Selection Section Component
  const handleRemovePlantIcon = () => {
    setPlantBackgroundImg("");
    setPlantIconBase64("");
    setPlantIconHeight("");
    setPlantIconWidth("");
    setLocalPlantHeight("");
    setLocalPlantWidth("");
    setPlantLogoErrors({ plantLogoHeight: "", plantLogoWidth: "" });
    if (plantInputFile.current) plantInputFile.current.value = "";
  };

  const PlantIconSelectionSection = () => {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          flexDirection: "column",
          width: "100%",
        }}
      >
        <Typography
          style={{
            marginBottom: "10px",
            marginTop: "10px",
            fontSize: "16px",
            fontWeight: 400,
            color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
          }}
        >
          Plant Icon
        </Typography>
        <Box style={{ display: "flex", gap: "50px", alignItems: "center" }}>
          <Box
            sx={{
              height: "100px",
              width: "100px",
              border: "2px solid #008CD7",
              borderRadius: "50%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundImage: `url(${plantBackgroundImg})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center center",
              backgroundSize: `${localPlantWidth || plantIconWidth || plantImageWidth}px ${localPlantHeight || plantIconHeight || plantImageHeight}px`,
              cursor: "pointer",
              position: "relative",
            }}
            onClick={handlePlantLogoClick}
          >
            <input
              style={{ display: "none" }}
              ref={plantInputFile}
              onChange={handlePlantImageUpload}
              type="file"
              accept=".png,.PNG,.jpg,.jpeg,.gif"
              multiple={false}
            />
            {plantBackgroundImg === "" ? (
              <AddIcon
                style={{
                  width: "40px",
                  height: "40px",
                  color: "#008CD7",
                  cursor: "pointer",
                }}
              />
            ) : (
              <>
                <img
                  src={plantBackgroundImg}
                  alt="Plant Icon Preview"
                  style={{
                    width: localPlantWidth || plantIconWidth || plantImageWidth,
                    height:
                      localPlantHeight || plantIconHeight || plantImageHeight,
                    objectFit: "contain",
                    borderRadius: "50%",
                  }}
                />
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRemovePlantIcon();
                  }}
                  sx={{
                    position: "absolute",
                    top: 2,
                    right: 2,
                    background: "rgba(255,255,255,0.7)",
                    zIndex: 2,
                  }}
                  aria-label="Remove plant icon"
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </>
            )}
          </Box>
          <Box>
            <Box style={{ display: "flex", flexDirection: "column" }}>
              <TextField
                label="Height"
                variant="standard"
                disabled={true}
                type="number"
                InputProps={{
                  inputProps: { min: 20, max: 40 },
                }}
                sx={{
                  width: "80px",
                  marginBottom: "10px",
                  "& .MuiInputLabel-root": {
                    color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: "var(--PrimaryText)",
                  },
                }}
                value={localPlantHeight}
                onChange={(e) => handleLocalPlantHeightChange(e.target.value)}
                onBlur={handlePlantHeightBlur}
                error={!!plantLogoErrors.plantLogoHeight}
                helperText={plantLogoErrors.plantLogoHeight}
              />
              <TextField
                label="Width"
                variant="standard"
                type="number"
                disabled={true}
                InputProps={{
                  inputProps: { min: 20, max: 40 },
                }}
                sx={{
                  width: "80px",
                  marginBottom: "20px",
                  "& .MuiInputLabel-root": {
                    color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: "var(--PrimaryText)",
                  },
                }}
                value={localPlantWidth}
                onChange={(e) => handleLocalPlantWidthChange(e.target.value)}
                onBlur={handlePlantWidthBlur}
                error={!!plantLogoErrors.plantLogoWidth}
                helperText={plantLogoErrors.plantLogoWidth}
              />
            </Box>
          </Box>
        </Box>
        <Typography
          style={{
            fontSize: "12px",
            color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
            marginTop: "5px",
          }}
        >
          Allowed formats: PNG, JPG, JPEG, GIF (Height & Width: 70px)
        </Typography>
      </Box>
    );
  };

  // Plant icon validation function
  const validatePlantLogo = () => {
    let hasErrors = false;
    let newPlantLogoErrors = { plantLogoHeight: "", plantLogoWidth: "" };

    if (
      plantIconHeight &&
      (!Number.isFinite(Number(plantIconHeight)) ||
        Number(plantIconHeight) <= 5 ||
        Number(plantIconHeight) >= 70)
    ) {
      newPlantLogoErrors.plantLogoHeight =
        "Height must be between 5 and 70 pixels.";
      hasErrors = true;
    }

    if (
      plantIconWidth &&
      (!Number.isFinite(Number(plantIconWidth)) ||
        Number(plantIconWidth) <= 5 ||
        Number(plantIconWidth) >= 70)
    ) {
      newPlantLogoErrors.plantLogoWidth =
        "Width must be between 5 and 70 pixels.";
      hasErrors = true;
    }

    setPlantLogoErrors(newPlantLogoErrors);
    return hasErrors;
  };

  // Logo validation function
  const validateLogo = () => {
    let hasErrors = false;
    let newLogoErrors = { logoHeight: "", logoWidth: "" };
    console.log(
      "Validating logo with height:!Number.isFinite(Number(iconHeight))",
      !Number.isFinite(Number(iconHeight)),
      " parseInt(iconHeight, 10) <= 5",
      parseInt(iconHeight, 10) <= 5,
      "and width:parseInt(iconHeight, 10) >= 70",
      parseInt(iconHeight, 10) >= 70,
      "iconHeight",
      iconHeight,
    );
    console.log(
      "Validating logo with height:!Number.isFinite(Number(iconWidth))",
      !Number.isFinite(Number(iconWidth)),
      " parseInt(iconWidth, 10) <= 5",
      parseInt(iconWidth, 10) <= 5,
      "and width:parseInt(iconWidth, 10) >= 70",
      parseInt(iconWidth, 10) >= 70,
      "iconWidth",
      iconWidth,
    );
    if (
      iconHeight &&
      (!Number.isFinite(Number(iconHeight)) ||
        Number(iconHeight) <= 5 ||
        Number(iconHeight) >= 70)
    ) {
      newLogoErrors.logoHeight = "Height must be between 5 and 70 pixels.";
      hasErrors = true;
    }

    if (
      iconWidth &&
      (!Number.isFinite(Number(iconWidth)) ||
        Number(iconWidth) <= 5 ||
        Number(iconWidth) >= 70)
    ) {
      newLogoErrors.logoWidth = "Width must be between 5 and 70 pixels.";
      hasErrors = true;
    }

    setLogoErrors(newLogoErrors);
    return hasErrors;
  };

  // Toggle device expansion
  const toggleDeviceExpansion = (deviceId) => {
    setExpandedDevices((prev) => ({
      ...prev,
      [deviceId]: !prev[deviceId],
    }));
  };

  const getProjectNamecallback = (responseData) => {
    console.log("project name response data", responseData);
    if (responseData && responseData.data && responseData.data.data) {
      setCurrentProject(responseData.data.data);
    }

    getdevicetags1(projectname, userDetails.Projectlist, (responseData) => {
      if (responseData && responseData.data && responseData.data.devices) {
        const formattedDevices = responseData.data.devices.map((device) => ({
          ...device,
          tagdetails: Array.isArray(device.tagdetails)
            ? device.tagdetails.map((tag) => ({
                ...tag,
                TagID: tag.TagID || "",
                TagName: tag.TagName || "",
                Unit: tag.Unit || "",
                DataType: tag.DataType || "",
                selectable: true,
              }))
            : [],
        }));

        const filteredData = {
          ...responseData,
          data: {
            ...responseData.data,
            devices: formattedDevices,
          },
        };

        setAssetData(filteredData);
      } else {
        showToast("Error", "Invalid asset data received", "Error");
      }
      setAssetIsLoading(false);
    });
  };

  useEffect(() => {
    // Convert asset data to tree format for tag selection popup
    const treeData = convertAssetDataToTreeFormat(assetData);
    setLeft(treeData);
  }, [assetData]);

  // Fetch asset data for tag selection
  // Fetch asset data for tag selection
  const fetchAssetData = () => {
    if (!userDetails.Projectid) {
      showToast("Error", "No project ID found", "Error");
      return;
    }

    setAssetIsLoading(true);
    getProjectName(getProjectNamecallback);
  };

  // Convert asset data to tree format for tag selection
  // const convertAssetDataToTreeFormat = (assetData) => {
  //   // Create predefined options first
  //   const predefinedDevices = [
  //     {
  //       title: "Target",
  //       key: "DEVICE_TARGET",
  //       alias: "Target",
  //       children: [{
  //         title: "Target",
  //         key: "TAG_TARGET",
  //         alias: "Target",
  //         storage: ['SUM', 'AVG', 'MIN', 'MAX'],
  //         parent: "DEVICE_TARGET",
  //         unit: ""
  //       }]
  //     },
  //     {
  //       title: "Yearly Baseline",
  //       key: "DEVICE_YEARLY_BASELINE",
  //       alias: "Yearly Baseline",
  //       children: [{
  //         title: "Yearly Baseline",
  //         key: "TAG_YEARLY_BASELINE",
  //         alias: "Yearly Baseline",
  //         storage: ['SUM', 'AVG', 'MIN', 'MAX'],
  //         parent: "DEVICE_YEARLY_BASELINE",
  //         unit: ""
  //       }]
  //     }
  //   ];

  //   // Get existing devices from API data
  //   const existingDevices = assetData?.data?.devices ? assetData.data.devices.map(device => ({
  //     title: device.DeviceName,
  //     key: device.DeviceID,
  //     alias: device.DeviceName,
  //     children: device.tagdetails?.map(tag => ({
  //       title: tag.TagName,
  //       key: tag.TagID,
  //       alias: tag.TagName,
  //       storage: ['SUM', 'AVG', 'MIN', 'MAX'],
  //       parent: device.DeviceID,
  //       unit: tag.Unit
  //     })) || []
  //   })) : [];

  //   // Combine predefined devices with existing devices
  //   return [...predefinedDevices, ...existingDevices];
  // };

  const convertAssetDataToTreeFormat = (assetData) => {
    // 1. Create Predefined Nodes (Target, Yearly Baseline)
    const predefinedDevices = [
      {
        title: "Target",
        key: "DEVICE_TARGET",
        alias: "Target",
        children: [
          {
            title: "Target",
            key: "TAG_TARGET",
            alias: "Target",
            storage: ["SUM", "AVG", "MIN", "MAX"],
            parent: "DEVICE_TARGET",
            unit: "",
          },
        ],
      },
      {
        title: "Yearly Baseline",
        key: "DEVICE_YEARLY_BASELINE",
        alias: "Yearly Baseline",
        children: [
          {
            title: "Yearly Baseline",
            key: "TAG_YEARLY_BASELINE",
            alias: "Yearly Baseline",
            storage: ["SUM", "AVG", "MIN", "MAX"],
            parent: "DEVICE_YEARLY_BASELINE",
            unit: "",
          },
        ],
      },
    ];

    // 2. Get the devices list from the API response
    const devices = assetData?.data?.devices || [];

    // 3. LOGIC FOR "ALL" PROJECTS (Hierarchical View)
    if (projectId === "All") {
      // Group devices by ProjectName
      const devicesByProject = devices.reduce((groups, device) => {
        // Use ProjectName from API, or 'Unknown Project' if missing
        const projName = currentProject[device.ProjectID];
        console.log("------tagggggggggg", device);

        if (!groups[projName]) {
          groups[projName] = [];
        }
        groups[projName].push(device);
        return groups;
      }, {});

      // Map the groups into Tree Nodes
      const projectNodes = Object.keys(devicesByProject).map((projectName) => {
        // Get the first device to extract ProjectID (all devices in same project have same ProjectID)
        const firstDevice = devicesByProject[projectName][0];

        // Define predefined devices ONCE per project
        // const predefinedDevicesProject = [
        //   {
        //     title: "Target",
        //     key: `DEVICE_TARGET~${firstDevice.ProjectID}`,
        //     alias: "Target",
        //     children: [{
        //       title: "Target",
        //       key: `TAG_TARGET~${firstDevice.ProjectID}`,
        //       ProjectID: firstDevice.ProjectID,
        //       alias: "Target",
        //       storage: ['SUM', 'AVG', 'MIN', 'MAX'],
        //       parent: `DEVICE_TARGET~${firstDevice.ProjectID}`,
        //       unit: ""
        //     }]
        //   },
        //   {
        //     title: "Yearly Baseline",
        //     key: `DEVICE_YEARLY_BASELINE~${firstDevice.ProjectID}`,
        //     alias: "Yearly Baseline",
        //     children: [{
        //       title: "Yearly Baseline",
        //       key: `TAG_YEARLY_BASELINE~${firstDevice.ProjectID}`,
        //       ProjectID: firstDevice.ProjectID,
        //       alias: "Yearly Baseline",
        //       storage: ['SUM', 'AVG', 'MIN', 'MAX'],
        //       parent: `DEVICE_YEARLY_BASELINE~${firstDevice.ProjectID}`,
        //       unit: ""
        //     }]
        //   }
        // ];

        // Map devices to tree nodes
        const deviceNodes = devicesByProject[projectName].map((device) => ({
          title: device.DeviceName,
          key: device.DeviceID,
          alias: device.DeviceName,
          children:
            device.tagdetails?.map((tag) => ({
              title: tag.TagName,
              key: tag.TagID,
              ProjectID: device.ProjectID,
              alias: tag.TagName,
              storage: ["SUM", "AVG", "MIN", "MAX"],
              parent: device.DeviceID,
              unit: tag.Unit,
            })) || [],
        }));

        return {
          title: projectName,
          key: `PROJ_${projectName}`,
          alias: projectName,
          children: [...deviceNodes],
        };
      });

      return [...projectNodes];
    }

    // 4. LOGIC FOR SINGLE PROJECT (Flat View)
    const singleProjectNodes = devices.map((device) => ({
      title: device.DeviceName,
      key: device.DeviceID,
      alias: device.DeviceName,
      children:
        device.tagdetails?.map((tag) => ({
          title: tag.TagName,
          key: tag.TagID,
          ProjectID: device.ProjectID,
          alias: tag.TagName,
          storage: ["SUM", "AVG", "MIN", "MAX"],
          parent: device.DeviceID,
          unit: tag.Unit,
        })) || [],
    }));

    //Commented out predefined
    // return [...predefinedDevices, ...singleProjectNodes];
    return [...singleProjectNodes];
  };

  // Get device options for dropdown
  const getDeviceOptions = () => {
    if (!assetData?.data?.devices) return [];
    return assetData.data.devices.map((device) => ({
      value: device.DeviceID,
      label: device.DeviceName,
    }));
  };

  // Get tag options for selected device
  const getTagOptions = () => {
    if (!assetData?.data?.devices || !selectedDeviceId) return [];

    const selectedDevice = assetData.data.devices.find(
      (device) => device.DeviceID === selectedDeviceId,
    );
    if (!selectedDevice || !selectedDevice.tagdetails) return [];

    return selectedDevice.tagdetails.map((tag) => ({
      value: tag.TagID,
      label: `${tag.TagName} ${tag.Unit ? `(${tag.Unit})` : ""}`,
    }));
  };

  // Load parameters from localStorage on component mount
  useEffect(() => {
    loadParameters();
    // Fetch asset data when component mounts
    if (userDetails.Projectid) {
      fetchAssetData();
    }
  }, [userDetails.Projectid, projectname, overviewbarConfigCollection]);

  // Filter parameters when search query changes
  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredParameters(parameters);
    } else {
      const lowercaseQuery = searchQuery.toLowerCase();
      const filtered = parameters.filter(
        (param) =>
          param.name.toLowerCase().includes(lowercaseQuery) ||
          (param.targetSelection.manualValue &&
            param.targetSelection.manualValue
              .toString()
              .includes(lowercaseQuery)) ||
          (param.targetSelection.manualUnit &&
            param.targetSelection.manualUnit
              .toLowerCase()
              .includes(lowercaseQuery)),
      );
      setFilteredParameters(filtered);
    }
  }, [parameters, searchQuery]);

  // Load parameters from localStorage
  const loadParameters = () => {
    console.log(
      "overviewbarConfigCollection----////Loading",
      overviewbarConfigCollection,
    );
    setIsLoading(true);

    try {
      const storageKey = `parameterConfigurations_${userDetails.Organizationid || "default"}`;
      const savedParameters = overviewbarConfigCollection;
      //  let currentExportParameters = [];
      // for (const param of savedParameters) {
      //   if(param.showOrgLevel == true || param.showOrgLevel == "true"){
      //     currentExportParameters.push(param.id);
      //   }
      // }
      // setExportParameterArr(currentExportParameters);

      if (savedParameters) {
        const parsedParameters = overviewbarConfigCollection;
        // Ensure all parameters have display properties
        const updatedParameters = parsedParameters.map((param, index) => ({
          ...param,
          id: param.id || `param_${Date.now()}_${index}`,
          displayOrder:
            param.DisplayOrder !== undefined ? param.DisplayOrder : index,
          isDisplayed:
            param.isDisplayed !== undefined ? param.isDisplayed : true,
        }));
        setParameters(updatedParameters);
        setFilteredParameters(updatedParameters);
      }
    } catch (error) {
      console.log("Error loading parameters from localStorage:", error);
      showToast("Error", "Failed to load parameter configurations", "Error");
    } finally {
      setIsLoading(false);
    }
  };

  // Save parameters to localStorage
  const saveParameters = (updatedParameters) => {
    try {
      const storageKey = `parameterConfigurations_${userDetails.Organizationid || "default"}`;
      localStorage.setItem(storageKey, JSON.stringify(updatedParameters));
      return true;
    } catch (error) {
      console.log("Error saving parameters to localStorage:", error);
      return false;
    }
  };

  // Generate unique ID for new parameter
  const generateId = () =>
    `param_${Date.now()}_${Math.floor(Math.random() * 1000)}`;

  // In handleAddParameter function, add these lines:
  const handleAddParameter = () => {
    if (parameters.length >= MAX_PARAMETERS) {
      showToast(
        "Limit Reached",
        `Maximum ${MAX_PARAMETERS} parameters allowed. Please delete existing parameters to add new ones.`,
        "Warning",
      );
      return;
    }

    resetParameterStates();
    setParamId(generateId());
    setDisplayOrder(parameters.length);

    setIsEditMode(false);
    setOpenForm(true);
    setSaveStatus(0);
    setRequired(false);
    setSelectedDeviceId("");
    setSelectedTagId("");

    // Reset logo states
    setBackgroundimg("");
    setLogoErrors({ logoHeight: "", logoWidth: "" });
    if (inputFile.current) inputFile.current.value = "";

    setPlantBackgroundImg("");
    setPlantLogoErrors({ plantLogoHeight: "", plantLogoWidth: "" });
    setLocalPlantHeight("");
    setLocalPlantWidth("");
    if (plantInputFile.current) plantInputFile.current.value = "";
  };

  // In handleEditParameter function, add this line:
  const handleEditParameter = (parameter) => {
    console.log("Editing Parameter:", parameter);
    loadParameterFromObject(parameter);

    setIsEditMode(true);
    setOpenForm(true);
    setSaveStatus(0);
    setRequired(false);
    setSelectedDeviceId(parameter.deviceId || "");
    setSelectedTagId(parameter.tagSelection || "");

    // Load logo states
    setBackgroundimg(parameter?.iconData?.base64 || "");
    setLogoErrors({ logoHeight: "", logoWidth: "" });

    setPlantBackgroundImg(parameter?.plantDetails?.plantIconData?.base64 || "");
    setPlantLogoErrors({ plantLogoHeight: "", plantLogoWidth: "" });
  };

  // In handleCloseForm function, add these lines:
  const handleCloseForm = () => {
    setOpenForm(false);
    resetParameterStates();
    setSaveStatus(0);
    setRequired(false);
    setSelectedDeviceId("");
    setSelectedTagId("");

    // Reset logo states
    setBackgroundimg("");
    setLogoErrors({ logoHeight: "", logoWidth: "" });
    if (inputFile.current) inputFile.current.value = "";

    setPlantBackgroundImg("");
    setPlantLogoErrors({ plantLogoHeight: "", plantLogoWidth: "" });
    setLocalPlantHeight("");
    setLocalPlantWidth("");
    if (plantInputFile.current) plantInputFile.current.value = "";

    setLockedAggregation(null);
    setChecked([]);
    setCheckedKeys([]);
    setDisabled([true, true, true, true, true, true, true]);
    setExpandedKeys([]);
    setSelectedKeys([]);
    setAutoExpandParent(true);
    setSearchText("");
  };

  // Handle saving the parameter form
  const handleSaveForm = () => {
    if (!paramName) {
      setRequired(true);
      return;
    }

    // Require at least one tag if parameterType is 'tag'
    if (
      parameterType === "tag" &&
      (!selectedTags || selectedTags.length === 0)
    ) {
      showToast(
        "Validation Error",
        "Please select at least one tag for tag parameters.",
        "Error",
      );
      return;
    }

    // Check for duplicate parameter names
    if (isDuplicateParameterName(paramName, paramId)) {
      setRequired(true);
      showToast(
        "Validation Error",
        "Parameter name already exists. Please use a different name.",
        "Error",
      );
      return;
    }

    // Check for validation errors
    const hasValidationErrors = Object.values(validationErrors).some(
      (error) => error !== "",
    );

    if (hasValidationErrors) {
      setRequired(true);
      showToast(
        "Validation Error",
        "Please fix all validation errors before saving",
        "Error",
      );
      return;
    }

    // Validate logo dimensions
    const hasLogoErrors = validateLogo();
    if (hasLogoErrors) {
      showToast(
        "Validation Error",
        "Please fix logo dimension errors",
        "Error",
      );
      return;
    }

    // Validate plant logo dimensions
    const hasPlantLogoErrors = validatePlantLogo();
    if (hasPlantLogoErrors) {
      showToast(
        "Validation Error",
        "Please fix plant logo dimension errors",
        "Error",
      );
      return;
    }

    setIsLoading(true);

    try {
      const currentParameter = getCurrentParameterObject();
      let updatedParameters;

      if (isEditMode) {
        // Update existing parameter
        updatedParameters = parameters.map((param) =>
          param.id === currentParameter.id ? currentParameter : param,
        );
      } else {
        // Add new parameter
        updatedParameters = [...parameters, currentParameter];
      }
      console.log("Updated Parameters:", updatedParameters);
      const success = saveParameters(updatedParameters);

      if (success) {
        setParameters(updatedParameters);
        setFilteredParameters(updatedParameters);
        setSaveStatus(1); // Success

        // Close form after a short delay to show success message
        setTimeout(() => {
          setOpenForm(false);
          resetParameterStates();
          setSelectedDeviceId("");
          setSelectedTagId("");
        }, 1500);
      } else {
        setSaveStatus(2); // Error
      }
    } catch (error) {
      console.log("Error saving parameter:", error);
      setSaveStatus(2); // Error
    } finally {
      setIsLoading(false);
    }
  };

  const getOverviewConfigcallback = (res) => {
    if (!res || !res.data) {
      console.log(
        "getOverviewConfigcallback: response or data is undefined",
        res,
      );
      return;
    }

    if (res.data && res.data.success && res.data.success == true) {
      let configdata = res.data.data;
      let currentExportParameters = [];

      const filteredOverviewConfig = configdata.map((param, idx) => {
        if (param.showOrgLevel == true || param.showOrgLevel == "true") {
          currentExportParameters.push(param.id);
        }
        let TagIDArray = param.TagID;
        // let finalTagIDArray = [];
        // for(let j=0;j<TagIDArray.length;j++){
        //   const parameter = TagIDArray[j];
        //   finalTagIDArray.push(`${parameter.TagID}~${parameter.DeviceName || ''}~${parameter.TagName || ''}~${parameter.DeviceName || ''}~${parameter.TagName || ''}~${parameter.RepresentType}`)
        // }
        // console.log("finalTagIDArray",finalTagIDArray)
        return {
          id: param.id, // or use a unique id from backend if available
          name: param.ParameterName || "",
          parameterType:
            param.Type === "Tag"
              ? "tag"
              : param.Type === "Manual"
                ? "manual"
                : "",
          selectedDevices: [], // If you have device info, map it here
          selectedTags: param.tagDetailsArray,
          targetSelection: param.tagSelection || {
            yearlyBaseline: param.Type === "YEARLYBASELINE",
            target: param.Type === "TARGET",
            manualValue: "",
            manualUnit: "",
          },
          aggregation:
            param.Aggregations && param.Aggregations.length > 0
              ? param.Aggregations[0]
              : "Sum",
          timePeriod: param.TimePeriod || "Today",
          unitSelection: param.UnitSelection || "Unit",
          iconPath: param.IconPath || "",
          iconData: param.IconData || { base64: "", height: "", width: "" },
          showInCollapsedMode: !!param.isShowCollapsedMode,
          showAsCriticalParameter: !!param.isCriticalParameter,
          displayOrder:
            typeof param.DisplayOrder === "number" ? param.DisplayOrder : idx,
          isDisplayed: true,
          plantDetails: {
            clientType: param.PlantDetails?.ClientType || "organization",
            clientValue: param.PlantDetails?.ClientValue || "",
            projectType: param.PlantDetails?.ProjectType || "project",
            projectValue: param.PlantDetails?.ProjectValue || "",
            selectedProjectDetail:
              param.PlantDetails?.SelectedProjectDetail || "Country",
            customFieldType:
              param.PlantDetails?.CustomFieldType || "projectDetail",
            selectedAdditionalFieldDetail:
              param.PlantDetails?.selectedAdditionalFieldDetail || "Country",
            customFieldName: param.PlantDetails?.customFieldName || "",
            customFieldValue: param.PlantDetails?.CustomFieldValue || "",
            plantIconPath: param.PlantDetails?.plantIconPath || "",
            plantIconData: param.PlantDetails?.plantIconData || {
              base64: "",
              height: "",
              width: "",
            },
          },
        };
      });
      setExportParameterArr(currentExportParameters);
      console.log("filteredOverviewConfig----", filteredOverviewConfig);
      console.log("configdata----", configdata);
      dispatch(updateoverviewbarCollection(configdata));
      dispatch(updateoverviewbarConfigCollection(filteredOverviewConfig));
    }
  };

  const postoverviewconfigcallback = (response, status) => {
    console.log("postoverviewconfigcallback", response, status);
    if (status === 200 || status === 201) {
      setCreatedSuccess(true);
      setCreatedSuccessMsg("Configuration Successfully saved");
      getOverviewConfig(getOverviewConfigcallback);
    } else {
      setNotCreatedSuccess(true);
      setNotCreatedSuccessMsg(response.data.message || "Error occurred");
    }
  };

  //Handl saving to database
  const handleSaveOverviewConfig = () => {
    let overviewBarGroups = [];

    console.log(
      "handleSaveOverviewConfig - filteredParameters",
      filteredParameters,
    );
    for (let i = 0; i < filteredParameters.length; i++) {
      const param = filteredParameters[i];

      // Type logic
      let Type = "";
      if (param.parameterType === "tag") Type = "Tag";
      else if (param.parameterType === "manual") Type = "Manual";
      else if (param.targetSelection?.yearlyBaseline) Type = "YEARLYBASELINE";
      else if (param.targetSelection?.target) Type = "TARGET";

      // TagID, RepresentType, Aggregations
      let TagID = [];
      let RepresentType = "";
      let Aggregations = [];
      if (param.selectedTags && param.selectedTags.length > 0) {
        // Assuming selectedTags is an array of strings like "tagid~...~representtype"
        // const tagParts = param.selectedTags[0].split('~');
        // TagID = tagParts[0];
        // RepresentType = tagParts[tagParts.length - 1];
        // Aggregations: collect all represent types for all tags
        Aggregations = param.selectedTags.map((tagStr, index) => {
          const parts = tagStr.split("~");
          TagID.push(parts[0]);
          RepresentType = parts[parts.length - 1];
          if (parts[parts.length - 1] != "LIVE") return parts[parts.length - 1];
          return parts[parts.length - 2];
        });
      }
      let tagSelection = param.targetSelection;

      // TimePeriod: should be empty/invalid for RepresentType === 'LIVE'
      let TimePeriod = RepresentType === "LIVE" ? "" : param.timePeriod;

      // UnitSelection: use param.unitSelection or ''
      let UnitSelection = param.unitSelection || "";

      // IconPath: use param.iconPath or ''
      let IconPath = param.iconPath || "";

      // IconData: base64, height, width
      let IconData = {
        base64: param.iconData?.base64 || "",
        height: param.iconData?.height || "",
        width: param.iconData?.width || "",
      };

      // isShowCollapsedMode, isCriticalParameter, DisplayOrder
      let isShowCollapsedMode = !!param.showInCollapsedMode;
      let isCriticalParameter = !!param.showAsCriticalParameter;
      let DisplayOrder =
        typeof param.displayOrder === "number" ? param.displayOrder : i;

      // PlantDetails mapping
      let pd = param.plantDetails || {};
      let PlantDetails = {
        ClientType: pd.clientType,
        ClientValue: pd.clientType === "custom" ? pd.clientValue : "",
        ProjectType: pd.projectType,
        ProjectValue: pd.projectType === "custom" ? pd.projectValue : "",
        SelectedProjectDetail:
          pd.projectType === "projectDetail" ? pd.selectedProjectDetail : "",
        CustomFieldType: pd.customFieldType,
        CustomFieldValue:
          pd.customFieldType === "custom" ? pd.customFieldValue : "",
        selectedAdditionalFieldDetail:
          pd.customFieldType === "projectDetail"
            ? pd.selectedAdditionalFieldDetail
            : "",
      };
      let isDisplayed = param.isDisplayed || false;

      let currentParameter = {
        id: param.id,
        ParameterName: param.name,
        Type,
        TagID,
        RepresentType,
        Aggregations,
        TimePeriod,
        UnitSelection,
        tagSelection,
        IconPath,
        IconData,
        isShowCollapsedMode,
        isCriticalParameter,
        DisplayOrder,
        PlantDetails,
        isDisplayed,
      };

      overviewBarGroups.push(currentParameter);
    }
    console.log("overviewBarGroups to be sent", overviewBarGroups);
    postoverviewconfig(overviewBarGroups, postoverviewconfigcallback);
  };

  // Handle opening Display popup
  const handleOpenDisplayPopup = () => {
    // Sort parameters by display order for the popup
    const sortedParams = [...parameters].sort(
      (a, b) => a.displayOrder - b.displayOrder,
    );
    setDisplayParameters(sortedParams);
    setSelectedDisplayParams(
      sortedParams
        .filter((param) => param.isDisplayed)
        .map((param) => param.id),
    );
    setOpenDisplayPopup(true);
  };

  // Handle closing Display popup
  const handleCloseDisplayPopup = () => {
    setOpenDisplayPopup(false);
    setDisplayParameters([]);
    setSelectedDisplayParams([]);
  };

  // Handle saving display configuration
  const handleSaveDisplayConfig = () => {
    try {
      // Update parameters with new display configuration
      const updatedParameters = displayParameters.map((param, index) => ({
        ...param,
        displayOrder: index,
        isDisplayed: selectedDisplayParams.includes(param.id),
      }));

      const success = saveParameters(updatedParameters);

      if (success) {
        setParameters(updatedParameters);
        setFilteredParameters(updatedParameters);
        showToast(
          "Success",
          "Display configuration saved successfully",
          "Success",
        );
        handleCloseDisplayPopup();
      } else {
        showToast("Error", "Failed to save display configuration", "Error");
      }
    } catch (error) {
      console.log("Error saving display configuration:", error);
      showToast("Error", "Failed to save display configuration", "Error");
    }
  };

  // Handle parameter reordering
  const handleMoveParameter = (index, direction) => {
    const newDisplayParams = [...displayParameters];
    const newIndex = direction === "up" ? index - 1 : index + 1;

    if (newIndex >= 0 && newIndex < newDisplayParams.length) {
      // Swap parameters
      [newDisplayParams[index], newDisplayParams[newIndex]] = [
        newDisplayParams[newIndex],
        newDisplayParams[index],
      ];
      setDisplayParameters(newDisplayParams);
    }
  };

  // Handle display parameter checkbox change
  const handleDisplayParamCheck = (paramId, isChecked) => {
    if (isChecked) {
      setSelectedDisplayParams((prev) => [...prev, paramId]);
    } else {
      setSelectedDisplayParams((prev) => prev.filter((id) => id !== paramId));
    }
  };

  // Handle entering delete mode
  const handleEnterDeleteMode = () => {
    setDeleteMode(true);
    setDeleteParameterArr([]);
  };

  // Handle exiting delete mode
  const handleExitDeleteMode = () => {
    setDeleteMode(false);
    setDeleteParameterArr([]);
  };

  // Add this export function (implement your actual export logic)
  // const exportParameters = (selectedParameters) => {
  //   try {
  //     // Example export logic - replace with your actual implementation
  //     const exportData = selectedParameters.map(param => ({
  //       name: param.name,
  //       type: param.parameterType,
  //       configuration: param.selectedTags ? param.selectedTags.length : 'N/A'
  //     }));

  //     // Convert to CSV or JSON and download
  //     const dataStr = JSON.stringify(exportData, null, 2);
  //     const dataUri = 'data:application/json;charset=utf-8,'+ encodeURIComponent(dataStr);

  //     const exportFileDefaultName = `parameters_export_${new Date().toISOString().split('T')[0]}.json`;

  //     const linkElement = document.createElement('a');
  //     linkElement.setAttribute('href', dataUri);
  //     linkElement.setAttribute('download', exportFileDefaultName);
  //     linkElement.click();

  //     return true; // Return success
  //   } catch (error) {
  //     console.log('Export failed:', error);
  //     return false; // Return failure
  //   }
  // };

  const handleEnterExportMode = () => {
    setExportMode(true);
    //setExportParameterArr([]);
  };

  // Handle exiting export mode
  const handleExitExportMode = () => {
    setExportMode(false);
    //setExportParameterArr([]);
  };

  // Handle export parameter checkbox changes
  const handleExportCheck = (paramId, checked) => {
    // setExportParameterArr(prev => {
    //   if (checked) {
    //     return [...prev, paramId];
    //   } else {
    //     return prev.filter(id => id !== paramId);
    //   }
    // });
  };

  // Handle export selected parameters
  const handleExportSelected = () => {
    if (exportParameterArr.length === 0) {
      showToast("Warning", "Please select parameters to export", "Warning");
      return;
    }

    setShowExportDialog(true);
  };

  // Confirm parameter export
  const confirmExportParameter = () => {
    if (exportParameterArr.length === 0) {
      setShowExportDialog(false);
      return;
    }

    const selectedParameters = parameters.filter((param) =>
      exportParameterArr.includes(param.id),
    );

    // const success = exportParameters(selectedParameters);

    // if (success) {
    //   showToast('Success', `${exportParameterArr.length} parameter(s) exported successfully`, 'Success');
    // } else {
    //   showToast('Error', 'Failed to export parameters', 'Error');
    // }

    // setExportParameterArr([]);
    setExportMode(false);
    setShowExportDialog(false);
  };
  // Add validation helper functions after imports
  const isValidLength = (value, minLength, maxLength) => {
    return value.length >= minLength && value.length <= maxLength;
  };

  const containsSpacesOrSpecialChars = (value) => {
    const regex = /[^a-zA-Z0-9]/;
    return regex.test(value);
  };

  const isValidNumber = (value, min, max) => {
    const num = parseFloat(value);
    return !isNaN(num) && num >= min && num <= max;
  };

  // Add validation state after your existing state declarations
  const [validationErrors, setValidationErrors] = useState({
    paramName: "",
    manualValue: "",
    manualUnit: "",
    logoHeight: "",
    logoWidth: "",
    plantLogoHeight: "",
    plantLogoWidth: "",
    clientValue: "",
    projectValue: "",
    customFieldValue: "",
  });

  // Add a helper function to check for duplicate parameter names
  const isDuplicateParameterName = useCallback(
    (name, currentParamId) => {
      return parameters.some(
        (param) =>
          param.name.toLowerCase() === name.toLowerCase() &&
          param.id !== currentParamId,
      );
    },
    [parameters],
  );

  const handleParameterName = useCallback(
    (selectedValue) => {
      setParamName(selectedValue);
      if (selectedValue.length > 0) {
        // Check for duplicate names
        if (isDuplicateParameterName(selectedValue, paramId)) {
          setValidationErrors((prev) => ({
            ...prev,
            paramName:
              "Parameter name already exists. Please use a different name.",
          }));
          return;
        }
      }
      if (
        selectedValue.length > 0 &&
        (!isValidLength(selectedValue, 5, 25) ||
          containsSpacesOrSpecialChars(selectedValue))
      ) {
        setValidationErrors((prev) => ({
          ...prev,
          paramName:
            "Length must be between 5 and 25 with no special characters and whitespaces allowed.",
        }));
      } else {
        setValidationErrors((prev) => ({ ...prev, paramName: "" }));
      }
    },
    [isDuplicateParameterName, paramId],
  );

  const handleParameterType = useCallback((selectedValue) => {
    setParameterType(selectedValue);
  }, []);

  const handleManualValue = useCallback((selectedValue) => {
    setTargetManualValue(selectedValue);

    if (selectedValue && !isValidNumber(selectedValue, 0, 999999)) {
      setValidationErrors((prev) => ({
        ...prev,
        manualValue: "Value must be between 0 and 999999",
      }));
    } else {
      setValidationErrors((prev) => ({ ...prev, manualValue: "" }));
    }
  }, []);

  const handleManualUnit = useCallback((selectedValue) => {
    setTargetManualUnit(selectedValue);
    if (
      selectedValue.length > 0 &&
      (!isValidLength(selectedValue, 1, 10) ||
        containsSpacesOrSpecialChars(selectedValue))
    ) {
      setValidationErrors((prev) => ({
        ...prev,
        manualUnit:
          "Length must be between 1 and 10 with no special characters and whitespaces allowed.",
      }));
    } else {
      setValidationErrors((prev) => ({ ...prev, manualUnit: "" }));
    }
  }, []);

  const handleYearlyBaseline = useCallback((selectedValue) => {
    console.log("handleYearlyBaseline selectedValue", selectedValue);
    setTargetYearlyBaseline(selectedValue);
  }, []);

  const handleTarget = useCallback((selectedValue) => {
    console.log("handleTarget selectedValue", selectedValue);
    setTargetTarget(selectedValue);
  }, []);

  const handleShowInCollapsedMode = useCallback((selectedValue) => {
    console.log("handleShowInCollapsedMode selectedValue", selectedValue);
    setShowInCollapsedMode(selectedValue);
  }, []);

  const handleShowAsCriticalParameter = useCallback((selectedValue) => {
    console.log("handleShowAsCriticalParameter selectedValue", selectedValue);
    setShowAsCriticalParameter(selectedValue);
  }, []);
  // function handleSelectedParameter(selectedValue) {
  //   currentParameter.SelectedParameter = selectedValue;
  //   setCurrentParameter(currentParameter);
  // }

  // function handlePlantIconPath(selectedValue) {
  //   currentParameter.plantDetails.plantIconPath = selectedValue;
  //   setCurrentParameter(currentParameter);
  // }

  // Replace the existing handleCustomFieldType function
  const handleCustomFieldType = useCallback(
    (e) => {
      const fieldType = e.target.value;
      setPlantCustomFieldType(fieldType);

      // Initialize selectedAdditionalFieldDetail when switching to projectDetail type
      if (fieldType === "projectDetail") {
        setPlantSelectedAdditionalFieldDetail(
          plantSelectedAdditionalFieldDetail || "Country",
        );
      }

      // Clear custom values when switching to projectDetail
      if (fieldType !== "custom") {
        setPlantCustomFieldName("");
        setPlantCustomFieldValue("");
      }
    },
    [plantSelectedAdditionalFieldDetail],
  );

  // Replace the existing handleCustomFieldName function
  const handleCustomFieldName = useCallback((event) => {
    const name = event.target.value;
    setPlantCustomFieldName(name);
  }, []);

  // Replace the existing handleCustomFieldValue function
  const handleCustomFieldValue = useCallback((event) => {
    const value = event.target.value;
    setPlantCustomFieldValue(value);

    if (
      plantCustomFieldType === "custom" &&
      value.length > 0 &&
      !isValidLength(value, 1, 50)
    ) {
      setValidationErrors((prev) => ({
        ...prev,
        customFieldValue: "Length must be between 1 and 50 characters.",
      }));
    } else {
      setValidationErrors((prev) => ({ ...prev, customFieldValue: "" }));
    }
  }, []);

  // Replace the existing handleAdditionalFieldDetailSelection function
  const handleAdditionalFieldDetailSelection = useCallback((selectedValue) => {
    setPlantSelectedAdditionalFieldDetail(selectedValue);
  }, []);

  // Replace the existing getAdditionalFieldTextValue function
  const getAdditionalFieldTextValue = () => {
    if (plantCustomFieldType === "projectDetail") {
      return (
        projectDataArray[0]?.Projectdetails?.[
          plantSelectedAdditionalFieldDetail
        ] || "Not Available"
      );
    } else if (plantCustomFieldType === "custom") {
      return plantCustomFieldValue || "";
    }
    return "";
  };

  const handleClientType = (event) => {
    const type = event.target.value;
    setPlantClientType(type);
    // Clear custom value when switching to organization
    if (type === "organization") {
      setPlantClientValue("");
    }
  };

  const handleClientValue = (event) => {
    const value = event.target.value;
    setPlantClientValue(value);
  };

  // Add this after your state declarations
  const handleClientTypeCallback = useCallback((e) => {
    const type = e.target.value;
    setPlantClientType(type);
    // Clear custom value when switching to organization
    if (type !== "organization") {
      // Keep the value if switching to custom
    } else {
      setPlantClientValue("");
    }
  }, []);

  const handleClientValueCallback = useCallback((event) => {
    const value = event.target.value;
    setPlantClientValue(value);
    if (
      plantClientType === "custom" &&
      value.length > 0 &&
      (!isValidLength(value, 3, 50) || containsSpacesOrSpecialChars(value))
    ) {
      setValidationErrors((prev) => ({
        ...prev,
        clientValue:
          "Length must be between 3 and 50 with no special characters and whitespaces allowed.",
      }));
    } else {
      setValidationErrors((prev) => ({ ...prev, clientValue: "" }));
    }
  }, []);

  // Replace the existing handleProjectType function
  const handleProjectType = useCallback(
    (e) => {
      const projectType = e.target.value;
      setPlantProjectType(projectType);

      // Clear project value when switching types
      if (projectType !== "custom") {
        setPlantProjectValue("");
      }

      // Initialize selectedProjectDetail when switching to projectDetail type
      if (projectType === "projectDetail") {
        setPlantSelectedProjectDetail(plantSelectedProjectDetail || "Country");
      }
    },
    [plantSelectedProjectDetail],
  );

  // Replace the existing handleProjectValue function
  const handleProjectValue = useCallback((event) => {
    const value = event.target.value;
    setPlantProjectValue(value);

    if (
      plantProjectType === "custom" &&
      value.length > 0 &&
      (!isValidLength(value, 3, 50) || containsSpacesOrSpecialChars(value))
    ) {
      setValidationErrors((prev) => ({
        ...prev,
        projectValue:
          "Length must be between 3 and 50 with no special characters and whitespaces allowed.",
      }));
    } else {
      setValidationErrors((prev) => ({ ...prev, projectValue: "" }));
    }
  }, []);

  // Replace the existing handleProjectDetailSelection function
  const handleProjectDetailSelection = useCallback((selectedValue) => {
    setPlantSelectedProjectDetail(selectedValue);
  }, []);

  // Add this new function after your other handler functions
  const getProjectTextFieldValue = () => {
    if (plantProjectType === "project") {
      return projectDataArray[0]?.Projectname || "Not Available";
    } else if (plantProjectType === "projectDetail") {
      return (
        projectDataArray[0]?.Projectdetails?.[plantSelectedProjectDetail] ||
        "Not Available"
      );
    } else if (plantProjectType === "custom") {
      return plantProjectValue || "";
    }
    return "";
  };

  // Handle deletion of selected parameters
  const handleDeleteSelected = () => {
    if (deleteParameterArr.length === 0) {
      showToast("Info", "No parameters selected for deletion", "Info");
      return;
    }

    setDialogContent({
      title: "Delete Selected Parameters",
      message: `Are you sure you want to delete ${deleteParameterArr.length} selected parameter(s)?`,
    });

    setShowDialogDelete(true);
  };

  // Confirm parameter deletion
  const confirmDeleteParameter = () => {
    if (deleteParameterArr.length === 0) {
      setShowDialogDelete(false);
      return;
    }

    const updatedParameters = parameters.filter(
      (param) => !deleteParameterArr.includes(param.id),
    );
    const success = saveParameters(updatedParameters);

    if (success) {
      setParameters(updatedParameters);
      setFilteredParameters(updatedParameters);
      showToast(
        "Success",
        `${deleteParameterArr.length} parameter(s) deleted successfully`,
        "Success",
      );
    } else {
      showToast("Error", "Failed to delete parameters", "Error");
    }

    setDeleteParameterArr([]);
    setDeleteMode(false);
    setShowDialogDelete(false);
  };

  // Handle checkbox selection for delete mode
  const handleDeleteCheck = (paramId, isChecked) => {
    if (isChecked) {
      setDeleteParameterArr((prev) => [...prev, paramId]);
    } else {
      setDeleteParameterArr((prev) => prev.filter((id) => id !== paramId));
    }
  };

  // Handle parameter form field changes
  const handleParameterChange = (field, value) => {
    if (field === "selectedTags") {
      setSelectedTags(value);
    } else if (field === "timePeriod") {
      setTimePeriod(value);
    } else if (field === "unitSelection") {
      setUnitSelection(value);
    } else if (field === "parameterType") {
      setParameterType(value);
    } else if (field === "deviceId") {
      setSelectedDeviceId(value);
    } else if (field === "tagSelection") {
      setSelectedTagId(value);
    } else if (field === "targetSelection.manualValue") {
      setTargetManualValue(value);
    } else if (field === "iconPath") {
      setIconPath(value);
    }
  };

  // Handle device selection change
  const handleDeviceChange = (deviceId) => {
    setSelectedDeviceId(deviceId);
    setSelectedTagId(""); // Reset tag selection when device changes
    handleParameterChange("deviceId", deviceId);
    handleParameterChange("tagSelection", ""); // Reset tag selection in parameter
  };

  // Handle tag selection change
  const handleTagChange = (tagId) => {
    setSelectedTagId(tagId);
    handleParameterChange("tagSelection", tagId);
  };

  // Handle file upload
  const handleFileUpload = (info) => {
    if (info.file.status === "done") {
      // Create URL for preview (in a real app, you'd get this from the server)
      const previewUrl = URL.createObjectURL(info.file.originFileObj);

      setSelectedFile({
        file: info.file.originFileObj,
        preview: previewUrl,
      });

      // Update parameter with file name
      handleParameterChange("iconPath", info.file.name);

      showToast(
        "Success",
        `${info.file.name} uploaded successfully`,
        "Success",
      );
    }
  };

  // Show toast notification
  const showToast = (title, message, type = "Info") => {
    setToast({
      open: true,
      title,
      message,
      type,
    });
    setOpenToast(true);
  };

  // Close toast notification
  const handleCloseToast = () => {
    setToast({
      ...toast,
      open: false,
    });
    setOpenToast(false);
  };

  // Handle search input change
  const handleSearchChange = (value) => {
    setSearchQuery(value);
  };

  // Get device name by ID
  const getDeviceName = (deviceId) => {
    if (deviceId === "DEVICE_TARGET") return "Target";
    if (deviceId === "DEVICE_YEARLY_BASELINE") return "Yearly Baseline";
    if (!assetData?.data?.devices || !deviceId) return "Unknown Device";
    const device = assetData.data.devices.find((d) => d.DeviceID === deviceId);
    return device ? device.DeviceName : "Unknown Device";
  };

  // Get tag name by ID
  const getTagName = (deviceId, tagId) => {
    if (tagId === "TAG_TARGET") return "Target";
    if (tagId === "TAG_YEARLY_BASELINE") return "Yearly Baseline";
    if (!assetData?.data?.devices || !deviceId || !tagId) return "Unknown Tag";
    const device = assetData.data.devices.find((d) => d.DeviceID === deviceId);
    if (!device || !device.tagdetails) return "Unknown Tag";
    const tag = device.tagdetails.find((t) => t.TagID === tagId);
    return tag
      ? `${tag.TagName} ${tag.Unit ? `(${tag.Unit})` : ""}`
      : "Unknown Tag";
  };

  // Parameter Card component for the dashboard
  const ParameterCard = ({ parameter, index }) => {
    return (
      <Box
        key={index}
        sx={{
          display: "flex",
          flexDirection: "row",
          height: "180px",
          width: "394.5px",
          textAlign: "left",
          boxSizing: "border-box",
          overflowWrap: "break-word",
        }}
      >
        <Box
          sx={{
            height: "100%",
            width: "1.6%",
            background: "#0549B1", // Changed to blue color
          }}
        ></Box>
        <Box
          key={index}
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            width: "98.4%",
            background: getParameterBackgroundColor(parameter),
            //background: "var(--SecondaryBackground)",
            padding: "10px 10px 10px 10px",
            textAlign: "left",
            boxSizing: "border-box",
            overflowWrap: "break-word",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              gap: "4px",
            }}
          >
            {deleteMode ? (
              <Box sx={{ marginTop: "-2.65px", marginRight: "4px" }}>
                <CustomCheckbox
                  style={{ Padding: 0 }}
                  defaultValue={false}
                  onChange={(checked) =>
                    handleDeleteCheck(parameter.id, checked)
                  }
                />
              </Box>
            ) : null}
            <Typography
              sx={{
                fontFamily: "Roboto",
                fontSize: "20px",
                fontWeight: "700",
                color: "var(--PrimaryText)",
                marginTop: "-4px",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                overflow: "hidden",
              }}
            >
              {parameter.name}
            </Typography>
            <Box style={{ flexGrow: 1 }}></Box>
            {!deleteMode && !exportMode && (
              <Tooltip title="Edit">
                <IconButton
                  onClick={() => handleEditParameter(parameter)}
                  sx={{
                    color: theme === "light" ? "#008CD7" : "#40a9ff",
                    height: "30px",
                    width: "30px",
                    padding: "4px",
                  }}
                >
                  <EditIcon sx={{ height: "20px", width: "20px" }} />
                </IconButton>
              </Tooltip>
            )}
          </Box>

          <Typography
            className="config-heading"
            style={{
              fontSize: "16px",
              fontWeight: 700,
              color: "var(--PrimaryText)",
              marginRight: "24px",
              marginTop: "16px",
            }}
          >
            Parameter Details
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              fontSize: "16px",
              fontFamily: "Roboto",
              margin: "0px 0px 12px 0px",
              flexWrap: "wrap",
            }}
          >
            {parameter.parameterType === "tag" && (
              <>
                {parameter.deviceId && (
                  <Typography
                    className="config-heading"
                    style={{
                      fontSize: "14px",
                      fontWeight: 400,
                      color: "var(--PrimaryText)",
                      marginRight: "20px",
                      marginBottom: "4px",
                    }}
                  >
                    Device: {getDeviceName(parameter.deviceId)}
                  </Typography>
                )}
                <Typography
                  className="config-heading"
                  style={{
                    fontSize: "14px",
                    fontWeight: 400,
                    color: "var(--PrimaryText)",
                    marginRight: "20px",
                  }}
                >
                  Tag:{" "}
                  {parameter.deviceId && parameter.tagSelection
                    ? getTagName(parameter.deviceId, parameter.tagSelection)
                    : parameter.selectedTags &&
                        parameter.selectedTags.length > 0
                      ? `${parameter.selectedTags.length} tag(s) selected`
                      : "None"}
                </Typography>
              </>
            )}

            {parameter.parameterType === "target" && (
              <Typography
                className="config-heading"
                style={{
                  fontSize: "14px",
                  fontWeight: 400,
                  color: "var(--PrimaryText)",
                  marginRight: "20px",
                }}
              >
                Target:{" "}
                {parameter.targetSelection.yearlyBaseline
                  ? "Yearly Baseline"
                  : ""}
                {parameter.targetSelection.target ? "Target" : ""}
                {parameter.targetSelection.manualValue
                  ? ` (${parameter.targetSelection.manualValue} ${parameter.targetSelection.manualUnit})`
                  : ""}
              </Typography>
            )}

            {parameter.parameterType === "manual" && (
              <Typography
                className="config-heading"
                style={{
                  fontSize: "14px",
                  fontWeight: 400,
                  color: "var(--PrimaryText)",
                  marginRight: "20px",
                }}
              >
                Value: {parameter.targetSelection.manualValue}{" "}
                {parameter.targetSelection.manualUnit}
              </Typography>
            )}
          </Box>
        </Box>
      </Box>
    );
  };

  // Display Configuration Popup Component
  const DisplayConfigPopup = () => {
    if (!openDisplayPopup) return null;

    return (
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1300,
        }}
        onClick={handleCloseDisplayPopup}
      >
        <Box
          sx={{
            width: "600px",
            maxHeight: "600px",
            backgroundColor: "#FFFFFF",
            borderRadius: "8px",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header */}
          <Box
            sx={{
              padding: "20px 24px",
              backgroundColor: "#008CD7",
              color: "#FFFFFF",
            }}
          >
            <Typography
              sx={{
                fontSize: "24px",
                fontWeight: 600,
                margin: 0,
              }}
            >
              Display
            </Typography>
          </Box>

          {/* Content */}
          <Box
            sx={{
              padding: "20px 24px",
              flex: 1,
              overflow: "auto",
            }}
          >
            <Typography
              sx={{
                mb: 3,
                fontWeight: 400,
                fontSize: "16px",
                color: "#3C3C3C",
                lineHeight: 1.5,
              }}
            >
              Configure parameter display order and visibility. Use arrows to
              reorder parameters.
            </Typography>

            <Box sx={{ maxHeight: "300px", overflow: "auto" }}>
              {displayParameters.map((param, index) => (
                <Box
                  key={param.id}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    padding: "12px 16px",
                    mb: 1,
                    backgroundColor: "#F8F9FA",
                    borderRadius: "6px",
                    border: "1px solid #E9ECEF",
                    "&:hover": {
                      backgroundColor: "#E3F2FD",
                    },
                  }}
                >
                  <CustomCheckbox
                    defaultValue={selectedDisplayParams.includes(param.id)}
                    onChange={(checked) =>
                      handleDisplayParamCheck(param.id, checked)
                    }
                    style={{ marginRight: "12px" }}
                  />

                  <Typography
                    sx={{
                      flexGrow: 1,
                      fontWeight: 500,
                      fontSize: "16px",
                      color: "#3C3C3C",
                    }}
                  >
                    {param.name}
                  </Typography>

                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}
                  >
                    <IconButton
                      onClick={() => handleMoveParameter(index, "up")}
                      disabled={index === 0}
                      sx={{
                        color: "#008CD7",
                        padding: "4px",
                        "&:disabled": { color: "#ccc" },
                        "&:hover": { backgroundColor: "#E3F2FD" },
                      }}
                    >
                      <ArrowUpwardIcon sx={{ fontSize: "20px" }} />
                    </IconButton>

                    <IconButton
                      onClick={() => handleMoveParameter(index, "down")}
                      disabled={index === displayParameters.length - 1}
                      sx={{
                        color: "#008CD7",
                        padding: "4px",
                        "&:disabled": { color: "#ccc" },
                        "&:hover": { backgroundColor: "#E3F2FD" },
                      }}
                    >
                      <ArrowDownwardIcon sx={{ fontSize: "20px" }} />
                    </IconButton>
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>

          {/* Footer with buttons */}
          <Box
            sx={{
              padding: "16px 24px",
              backgroundColor: "#F8F9FA",
              borderTop: "1px solid #E9ECEF",
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
            }}
          >
            <CustomCancelButton
              onClick={handleCloseDisplayPopup}
              buttonText="Cancel"
            />
            <CustomButton onClick={handleSaveDisplayConfig} buttonText="Save" />
          </Box>
        </Box>
      </Box>
    );
  };

  // Tag Selection Popup Functions
  const handleToggle = useCallback(
    (value) => () => {
      const type = getTagType(value);

      // No type locked yet
      if (!selectedTagType) {
        setSelectedTagType(type);
        setChecked((prev) =>
          prev.includes(value)
            ? prev.filter((v) => v !== value)
            : [...prev, value],
        );
        return;
      }

      // Same type
      if (selectedTagType === type) {
        setChecked((prev) =>
          prev.includes(value)
            ? prev.filter((v) => v !== value)
            : [...prev, value],
        );

        // Reset type if no tags left
        if (checked.length === 1 && checked[0] === value) {
          setSelectedTagType(null);
        }
      } else {
        console.log(
          `You cannot select a ${type} tag when ${selectedTagType} tags are already selected.`,
        );
      }
    },
    [selectedTagType, checked, getTagType, setSelectedTagType, setChecked],
  );

  // Separate handler for right panel (already selected tags) - no type restrictions
  const handleToggleRight = useCallback(
    (value) => () => {
      setChecked((prev) =>
        prev.includes(value)
          ? prev.filter((v) => v !== value)
          : [...prev, value],
      );
    },
    [setChecked],
  );

  const findParentNode = (
    nodes,
    childKey,
    parent = null,
    parentHierarchy = { titles: [], aliases: [] },
  ) => {
    for (let node of nodes) {
      if (node.key === childKey) {
        return {
          parentTitle: parentHierarchy.titles.join("~"),
          parentAlias: parentHierarchy.aliases.join("~"),
          childTitle: node.title,
          childAlias: node.alias,
        };
      }
      if (node.children) {
        const newParentHierarchy = {
          titles: [...parentHierarchy.titles, node.title],
          aliases: [...parentHierarchy.aliases, node.alias],
        };
        const found = findParentNode(
          node.children,
          childKey,
          node,
          newParentHierarchy,
        );
        if (found) return found;
      }
    }
    return null;
  };

  const leftChecked = intersection(
    checked,
    left.map((item) => (typeof item === "string" ? item : item.key)),
  );
  const rightChecked = intersection(checked, right);
  const centerChecked = intersection(checked, center);

  // const handleCheckedRightTree = () => {
  //   if (checkedKeys.length === 0) return;

  //   if (dataMode === "live") {
  //     // Live mode: directly move tags without aggregation
  //     const output = checkedKeys.map((childKey) => {
  //       // Handle predefined tags differently in live mode
  //       if (childKey === "TAG_TARGET") {
  //         return `${childKey}~Target~Target~Target~Target~LIVE`;
  //       } else if (childKey === "TAG_YEARLY_BASELINE") {
  //         return `${childKey}~Yearly Baseline~Yearly Baseline~Yearly Baseline~Yearly Baseline~LIVE`;
  //       } else {
  //         // Regular tags
  //         const nodeInfo = findParentNode(left, childKey);
  //         const parentTitle = nodeInfo?.parentTitle || "UnknownParent";
  //         const childTitle = nodeInfo?.childTitle || childKey;
  //         const parentAlias = nodeInfo?.parentAlias || "UnknownParent";
  //         const childAlias = nodeInfo?.childAlias || childKey;
  //         return `${childKey}~${parentTitle}~${childTitle}~${parentAlias}~${childAlias}~LIVE`;
  //       }
  //     });

  //     const updatedRight = [...new Set([...right, ...output])];
  //     setRight(updatedRight);
  //   } else {
  //     // Historical mode: existing functionality with aggregation
  //     if (centerChecked.length === 0) return;

  //     const output = checkedKeys.flatMap((childKey) => {
  //       return centerChecked.map((centerItem) => {
  //         // Handle predefined tags differently
  //         if (childKey === "TAG_TARGET") {
  //           return `${childKey}~Target~Target~Target~Target~${centerItem}`;
  //         } else if (childKey === "TAG_YEARLY_BASELINE") {
  //           return `${childKey}~Yearly Baseline~Yearly Baseline~Yearly Baseline~Yearly Baseline~${centerItem}`;
  //         } else {
  //           // Regular tags
  //           const nodeInfo = findParentNode(left, childKey);
  //           const parentTitle = nodeInfo?.parentTitle || "UnknownParent";
  //           const childTitle = nodeInfo?.childTitle || childKey;
  //           const parentAlias = nodeInfo?.parentAlias || "UnknownParent";
  //           const childAlias = nodeInfo?.childAlias || childKey;
  //           return `${childKey}~${parentTitle}~${childTitle}~${parentAlias}~${childAlias}~${centerItem}`;
  //         }
  //       });
  //     });

  //     const updatedRight = [...new Set([...right, ...output])];
  //     setRight(updatedRight);
  //     setChecked(not(checked, centerChecked));
  //   }

  //   // Common cleanup
  //   setCheckedKeys([]);
  //   setDisabled([true, true, true, true, true, true, true]);
  // };

  // const handleCheckedLeftTree = () => {
  //   const outputArray = [...new Set(rightChecked.map((item) => item.split("~")[0]))];
  //   const newRight = not(right, rightChecked);
  //   setRight(newRight);
  //   setChecked(not(checked, rightChecked));

  //   // Check if we removed any predefined tags and update state accordingly
  //   const stillHasPredefinedTags = newRight.some(item =>
  //     item.includes("TAG_TARGET") || item.includes("TAG_YEARLY_BASELINE")
  //   );
  //   setHasPredefinedTags(stillHasPredefinedTags);

  //   // Reset data mode if no predefined tags remain
  //   if (!stillHasPredefinedTags) {
  //     setDataMode("live");
  //   }

  //   const seenTagValues = new Set();
  //   const outputObjects = newRight.reduce((acc, itemA) => {
  //     const parts = itemA.split("~");
  //     const deviceName = parts[0];
  //     const lastPart = parts[parts.length - 1];
  //     const middleParts = parts.slice(1, parts.length - 1).join(".");

  //     if (!seenTagValues.has(middleParts)) {
  //       seenTagValues.add(middleParts);
  //       acc.push({
  //         deviceName,
  //         tagValue: middleParts,
  //         aggregate: centerChecked.map((itemB) => itemB),
  //       });
  //     }

  //     return acc;
  //   }, []);
  // };

  const handleCheckedRightTree = () => {
    if (checkedKeys.length === 0) return;
    if (dataMode === "historical" && centerChecked.length === 0) return;

    // Prevent multiple aggregation selection for the same tag
    if (dataMode === "live") {
      for (let childKey of checkedKeys) {
        const exists = right.some((item) => {
          const parts = item.split("~");
          return parts[parts.length - 1] === "LIVE" && parts[0] === childKey;
        });
        if (exists) {
          showToast("Warning", "This tag has already been added in Live mode.", "Warning");
          return;
        }
      }
    } else {
      for (let childKey of checkedKeys) {
      for (let agg of centerChecked) {
        // Check if this tag+aggregation already exists in right
        const exists = right.some((item) => {
          const parts = item.split("~");
          // For live tags, aggregation is at -2, for historical at -1
          const isLive = parts[parts.length - 1] === "LIVE";
          const tagMatch = parts[0] === childKey;
          const aggMatch = isLive
            ? parts[parts.length - 2] === agg
            : parts[parts.length - 1] === agg;
          return tagMatch && aggMatch;
        });
        if (exists) {
          showToast(
            "Warning",
            `Multiple aggregation selection is not allowed for the same tag.`,
            "Warning",
          );
          return;
        }
      }
      }
    }

    // ...existing code...
    if (right.length > 0) {
      // Get the mode and aggregation of existing tags
      const firstTag = right[0];
      const parts = firstTag.split("~");
      const existingIsLive = parts[parts.length - 1] === "LIVE";
      const existingAggregation = existingIsLive
        ? parts[parts.length - 2]
        : parts[parts.length - 1];

      const currentIsLive = dataMode === "live";
      const currentAggregation = currentIsLive
        ? (lockedAggregation || center[0] || "Sum")
        : centerChecked[0];

      // Rule: Cannot mix live and historical tags
      if (existingIsLive !== currentIsLive) {
        showToast(
          "Warning",
          `Cannot mix ${existingIsLive ? "Live" : "Historical"} tags with ${currentIsLive ? "Live" : "Historical"} tags`,
          "Warning",
        );
        return;
      }

      // Rule: For live tags, aggregation is always auto-locked, no conflict possible
    }

    // ...existing code...
    if (dataMode === "live") {
      // Live mode: use default aggregation (no selection required)
      let aggregationToUse = lockedAggregation || center[0] || "Sum";
      if (!lockedAggregation) setLockedAggregation(aggregationToUse);

      const output = checkedKeys.flatMap((childKey) => {
        return [aggregationToUse].map((centerItem) => {
          if (childKey === "TAG_TARGET") {
            return `${childKey}~Target~Target~Target~Target~${centerItem}~LIVE`;
          } else if (childKey === "TAG_YEARLY_BASELINE") {
            return `${childKey}~Yearly Baseline~Yearly Baseline~Yearly Baseline~Yearly Baseline~${centerItem}~LIVE`;
          } else {
            const nodeInfo = findParentNode(left, childKey);
            const parentTitle = nodeInfo?.parentTitle || "UnknownParent";
            const childTitle = nodeInfo?.childTitle || childKey;
            const parentAlias = nodeInfo?.parentAlias || "UnknownParent";
            const childAlias = nodeInfo?.childAlias || childKey;
            return `${childKey}~${parentTitle}~${childTitle}~${parentAlias}~${childAlias}~${centerItem}~LIVE`;
          }
        });
      });

      const updatedRight = [...new Set([...right, ...output])];
      setRight(updatedRight);
      setChecked(not(checked, centerChecked));
    } else {
      // Historical mode: enforce locked aggregation
      let aggregationToUse = lockedAggregation || centerChecked[0];
      if (!lockedAggregation) setLockedAggregation(centerChecked[0]);

      // If lockedAggregation is already set, enforce it
      if (lockedAggregation && !centerChecked.includes(lockedAggregation)) {
        // replace centerChecked array with lockedAggregation
        aggregationToUse = lockedAggregation;
      }

      const output = checkedKeys.flatMap((childKey) => {
        return [aggregationToUse].map((centerItem) => {
          if (childKey === "TAG_TARGET") {
            return `${childKey}~Target~Target~Target~Target~${centerItem}`;
          } else if (childKey === "TAG_YEARLY_BASELINE") {
            return `${childKey}~Yearly Baseline~Yearly Baseline~Yearly Baseline~Yearly Baseline~${centerItem}`;
          } else {
            const nodeInfo = findParentNode(left, childKey);
            const parentTitle = nodeInfo?.parentTitle || "UnknownParent";
            const childTitle = nodeInfo?.childTitle || childKey;
            const parentAlias = nodeInfo?.parentAlias || "UnknownParent";
            const childAlias = nodeInfo?.childAlias || childKey;
            return `${childKey}~${parentTitle}~${childTitle}~${parentAlias}~${childAlias}~${centerItem}`;
          }
        });
      });

      const updatedRight = [...new Set([...right, ...output])];
      setRight(updatedRight);
      setChecked(not(checked, centerChecked));
    }

    // Common cleanup
    setCheckedKeys([]);
    setDisabled([true, true, true, true, true, true, true]);
  };

  const handleCheckedLeftTree = () => {
    const outputArray = [
      ...new Set(rightChecked.map((item) => item.split("~")[0])),
    ];
    const newRight = not(right, rightChecked);
    setRight(newRight);
    setChecked(not(checked, rightChecked));

    // Check if we removed any predefined tags and update state accordingly
    const stillHasPredefinedTags = newRight.some(
      (item) =>
        item.includes("TAG_TARGET") || item.includes("TAG_YEARLY_BASELINE"),
    );
    setHasPredefinedTags(stillHasPredefinedTags);

    // Reset lockedAggregation if no tags remain
    if (newRight.length === 0) {
      setLockedAggregation(null);
      setChecked([]);
      setCheckedKeys([]);
      setDisabled([true, true, true, true, true, true, true]);
      setExpandedKeys([]);
      setSelectedKeys([]);
      setAutoExpandParent(true);
      setSearchText("");
    }

    const seenTagValues = new Set();
    const outputObjects = newRight.reduce((acc, itemA) => {
      const parts = itemA.split("~");
      const deviceName = parts[0];
      const lastPart = parts[parts.length - 1];
      const middleParts = parts.slice(1, parts.length - 1).join(".");

      if (!seenTagValues.has(middleParts)) {
        seenTagValues.add(middleParts);
        acc.push({
          deviceName,
          tagValue: middleParts,
          aggregate: centerChecked.map((itemB) => itemB),
        });
      }

      return acc;
    }, []);
  };

  const onExpand = useCallback(
    (expandedKeysValue) => {
      setExpandedKeys(expandedKeysValue);
      setAutoExpandParent(false);
    },
    [setExpandedKeys, setAutoExpandParent],
  );

  const renderTreeNodes = useCallback(
    (nodes, level = 0) =>
      nodes.map((node) => ({
        ...node,
        title: (
          <span style={{ display: "flex", alignItems: "center" }}>
            {level > 0 ? (
              <Checkbox
                sx={{
                  padding: 0,
                  margin: 0,
                  marginRight: "43px",
                  color: "#008CD7",
                  "& .MuiSvgIcon-root": {
                    fontSize: "20px",
                    color: "#008CD7",
                    fill: "#008CD7",
                  },
                }}
                icon={
                  <LK_CheckboxUnchecked
                    color="#008CD7"
                    width="13px"
                    height="13px"
                  />
                }
                checkedIcon={
                  <LK_CheckboxChecked
                    color="#008CD7"
                    width="13px"
                    height="13px"
                  />
                }
                checked={checkedKeys?.includes(node.key) || false}
                onChange={() => {
                  // Check if there are already selected tags and validate unit
                  if (right.length > 0) {
                    // Get the unit of the first selected tag
                    const firstTag = right[0];
                    const firstTagKey = firstTag.split("~")[0];
                    let firstTagUnit = "";

                    // Find unit from the tree structure
                    const findNodeUnit = (nodes, key) => {
                      for (let n of nodes) {
                        if (n.key === key) return n.unit || "";
                        if (n.children) {
                          const found = findNodeUnit(n.children, key);
                          if (found !== null) return found;
                        }
                      }
                      return null;
                    };

                    firstTagUnit = findNodeUnit(left, firstTagKey) || "";
                    const currentUnit = node.unit || "";

                    // Skip validation for predefined tags (TARGET, YEARLY_BASELINE)
                    const isPredefinedCurrent =
                      node.key === "TAG_TARGET" ||
                      node.key === "TAG_YEARLY_BASELINE";
                    const isPredefinedFirst =
                      firstTagKey === "TAG_TARGET" ||
                      firstTagKey === "TAG_YEARLY_BASELINE";

                    if (
                      !isPredefinedCurrent &&
                      !isPredefinedFirst &&
                      firstTagUnit !== currentUnit
                    ) {
                      showToast(
                        "Warning",
                        `Cannot select tags with different units (${firstTagUnit || "None"} vs ${currentUnit || "None"})`,
                        "Warning",
                      );
                      return;
                    }
                  }

                  // Remove the special handling - treat all tags the same way
                  setCheckedKeys([node.key]);
                  setDisabled([true, true, true, true, true, true, true]);

                  (node.storage || []).map((item) => {
                    if (item === "SUM") {
                      item = "Summation";
                    } else if (item === "AVG") {
                      item = "Average";
                    } else if (item === "DIFF") {
                      item = "Difference";
                    } else if (item === "SVAL") {
                      item = "Start Value";
                    } else if (item === "EVAL") {
                      item = "End Value";
                    } else if (item === "MIN") {
                      item = "Minimum";
                    } else if (item === "MAX") {
                      item = "Maximum";
                    }

                    const index = center.indexOf(item);
                    if (index !== -1) {
                      setDisabled((prevDisabled) => {
                        const newDisabled = [...prevDisabled];
                        newDisabled[index] = false;
                        return newDisabled;
                      });
                    }
                  });
                }}
                tabIndex={-1}
                inputProps={{
                  "aria-labelledby": node.key,
                }}
              />
            ) : level > 1 ? (
              // Same logic for "All" project case
              <Checkbox
                sx={{
                  padding: 0,
                  margin: 0,
                  marginRight: "43px",
                  color: "#008CD7",
                  "& .MuiSvgIcon-root": {
                    fontSize: "20px",
                    color: "#008CD7",
                    fill: "#008CD7",
                  },
                }}
                icon={
                  <LK_CheckboxUnchecked
                    color="#008CD7"
                    width="13px"
                    height="13px"
                  />
                }
                checkedIcon={
                  <LK_CheckboxChecked
                    color="#008CD7"
                    width="13px"
                    height="13px"
                  />
                }
                checked={checkedKeys?.includes(node.key) || false}
                onChange={() => {
                  // Check if there are already selected tags and validate unit
                  if (right.length > 0) {
                    // Get the unit of the first selected tag
                    const firstTag = right[0];
                    const firstTagKey = firstTag.split("~")[0];
                    let firstTagUnit = "";

                    // Find unit from the tree structure
                    const findNodeUnit = (nodes, key) => {
                      for (let n of nodes) {
                        if (n.key === key) return n.unit || "";
                        if (n.children) {
                          const found = findNodeUnit(n.children, key);
                          if (found !== null) return found;
                        }
                      }
                      return null;
                    };

                    firstTagUnit = findNodeUnit(left, firstTagKey) || "";
                    const currentUnit = node.unit || "";

                    // Skip validation for predefined tags (TARGET, YEARLY_BASELINE)
                    const isPredefinedCurrent =
                      node.key === "TAG_TARGET" ||
                      node.key === "TAG_YEARLY_BASELINE";
                    const isPredefinedFirst =
                      firstTagKey === "TAG_TARGET" ||
                      firstTagKey === "TAG_YEARLY_BASELINE";

                    if (
                      !isPredefinedCurrent &&
                      !isPredefinedFirst &&
                      firstTagUnit !== currentUnit
                    ) {
                      showToast(
                        "Warning",
                        `Cannot select tags with different units (${firstTagUnit || "None"} vs ${currentUnit || "None"})`,
                        "Warning",
                      );
                      return;
                    }
                  }

                  // Same logic - no special handling
                  setCheckedKeys([node.key]);
                  setDisabled([true, true, true, true, true, true, true]);

                  (node.storage || []).map((item) => {
                    if (item === "SUM") {
                      item = "Summation";
                    } else if (item === "AVG") {
                      item = "Average";
                    } else if (item === "DIFF") {
                      item = "Difference";
                    } else if (item === "SVAL") {
                      item = "Start Value";
                    } else if (item === "EVAL") {
                      item = "End Value";
                    } else if (item === "MIN") {
                      item = "Minimum";
                    } else if (item === "MAX") {
                      item = "Maximum";
                    }

                    const index = center.indexOf(item);
                    if (index !== -1) {
                      setDisabled((prevDisabled) => {
                        const newDisabled = [...prevDisabled];
                        newDisabled[index] = false;
                        return newDisabled;
                      });
                    }
                  });
                }}
                tabIndex={-1}
                inputProps={{
                  "aria-labelledby": node.key,
                }}
              />
            ) : null}
            {value3 === "name" ? node.title : node.alias}
          </span>
        ),
        children: node.children
          ? renderTreeNodes(node.children, level + 1)
          : undefined,
      })),
    [checkedKeys, value3, setCheckedKeys, setDisabled, center],
  );
  const getParameterBackgroundColor = (parameter) => {
    if (parameter.SelectedParameter || parameter.showAsCriticalParameter) {
      return theme === "dark" ? "#FFFFFF" : "#FFFFFF"; // White background for priority parameters
    }
    return theme === "dark" ? "#404040" : "#F5F5F5"; // Grey background for regular parameters
  };

  const handleOpenTagSelectionPopup = () => {
    // Initialize popup data from selected tags state
    setRight(selectedTags || []);
    setChecked([]);
    setCheckedKeys([]);
    setDataMode("live"); // Add this line to reset to live mode
    setOpenTagSelectionPopup(true);
  };

  const handleCloseTagSelectionPopup = useCallback(() => {
    setOpenTagSelectionPopup(false);
    setChecked([]);
    setCheckedKeys([]);
    setSearchText("");
    setSelectedDeviceId(""); // Clear middle section selection
    setAggregation("Sum"); // Reset aggregation to default
    setLockedAggregation(null); // Clear any locked aggregation
    setDisabled([true, true, true, true, true, true, true]); // Reset all aggregation options to disabled
    //setDataMode("live"); // Add this line
    //setHasPredefinedTags(false);
  }, [setOpenTagSelectionPopup, setChecked, setCheckedKeys, setSearchText]);

  // Handle saving tag selection
  const handleSaveTagSelection = () => {
    // Update selected tags state
    setSelectedTags(right);
    setOpenTagSelectionPopup(false);
    showToast("Success", "Tag selection saved successfully", "Success");
  };

  const onChange3 = ({ target: { value } }) => {
    setValue3(value);
  };

  // Tag Selection Popup Component
  const TagSelectionPopup = useMemo(() => {
    if (!openTagSelectionPopup) return null;

    return (() => {
      const customList = (title, items, isRightPanel = false) => (
        <Card
          sx={{
            width: "40%",
            height: "680px",
            borderRadius: "0px",
            boxShadow: "none",
            backgroundColor: theme === "dark" ? "#efefef" : "#FFFFFF",
            border: "1px solid #E0E0E0",
            display: "flex",
            flexDirection: "row",
          }}
        >
          {/* <CardHeader
        sx={{ px: 2, py: 1 }}
        subheader={
          <Box>
            <Box>
              <Input
                onChange={(e) => setSearchText(e.target.value)}
                addonAfter={<CloseOutlined />}
                placeholder="Search..."
                style={{ borderRadius: "4px" }}
              />
            </Box>
          </Box>
        }
      /> */}
          <Divider />

          <List
            sx={{
              bgcolor: theme === "dark" ? "#efefef" : "#FFFFFF",
              overflow: "auto",
            }}
            dense
            component="div"
            role="list"
          >
            {items.map((value) => {
              const labelId = `transfer-list-all-item-${value}-label`;

              return (
                <ListItemButton
                  key={value}
                  role="listitem"
                  onClick={
                    isRightPanel
                      ? handleToggleRight(value)
                      : handleToggle(value)
                  }
                  sx={{
                    "&:hover": {
                      backgroundColor: theme === "dark" ? "#f5f5f5" : "#FFFFFF",
                    },
                  }}
                >
                  <ListItemIcon>
                    <Checkbox
                      sx={{
                        padding: 0,
                        margin: 0,
                        color: "#008CD7",
                        "& .MuiSvgIcon-root": {
                          fontSize: "20px",
                          color: "#008CD7",
                          fill: "#008CD7",
                        },
                      }}
                      icon={
                        <LK_CheckboxUnchecked
                          color="#008CD7"
                          width="13px"
                          height="13px"
                        />
                      }
                      checkedIcon={
                        <LK_CheckboxChecked
                          color="#008CD7"
                          width="13px"
                          height="13px"
                        />
                      }
                      checked={checked.includes(value)}
                      tabIndex={-1}
                      inputProps={{
                        "aria-labelledby": labelId,
                      }}
                    />
                  </ListItemIcon>
                  <ListItemText
                    id={labelId}
                    primary={(() => {
                      const parts = value.split("~");
                      const isLive = parts[parts.length - 1] === "LIVE";
                      const aggregation = isLive
                        ? parts[parts.length - 2]
                        : parts[parts.length - 1];

                      let displayText;
                      if (projectId !== "All") {
                        if (value3 === "alias") {
                          displayText = parts
                            .filter((_, index) => ![0, 1, 2].includes(index))
                            .filter(
                              (_, index) =>
                                index < parts.length - (isLive ? 3 : 2),
                            )
                            .join(".");
                        } else if (value3 === "name") {
                          displayText = parts
                            .filter((_, index) => ![0, 3, 4].includes(index))
                            .filter(
                              (_, index) =>
                                index < parts.length - (isLive ? 3 : 2),
                            )
                            .join(".");
                        } else {
                          displayText = value;
                        }
                      } else {
                        if (value3 === "alias") {
                          displayText = parts
                            .filter((_, index) => ![0, 1, 2, 3].includes(index))
                            .filter(
                              (_, index) =>
                                index < parts.length - (isLive ? 3 : 2),
                            )
                            .join(".");
                        } else if (value3 === "name") {
                          displayText = parts
                            .filter((_, index) => ![0, 4, 5, 6].includes(index))
                            .filter(
                              (_, index) =>
                                index < parts.length - (isLive ? 3 : 2),
                            )
                            .join(".");
                        } else {
                          displayText = value;
                        }
                      }

                      return `${displayText} (${aggregation}${isLive ? " - Live" : ""})`;
                    })()}
                  />
                </ListItemButton>
              );
            })}
          </List>
        </Card>
      );

      const customListAgg = (items) => (
        <Card
          sx={{
            width: "148px",
            height: "156px",
            borderRadius: "0px",
            overflow: "auto",
            boxShadow: "none",
            border: "1px solid #E0E0E0",
          }}
        >
          <List
            sx={{
              padding: "8px",
              margin: "0px",
              bgcolor: "background.paper",
              overflow: "auto",
            }}
            dense
            component="div"
            role="list"
          >
            {items.map((value, key) => {
              const labelId = `transfer-list-all-item-${value}-label`;

              return (
                <ListItemButton
                  sx={{
                    padding: "0px",
                    margin: "0px",
                    gap: "0px",
                    "&:hover": {
                      backgroundColor: "#f5f5f5",
                    },
                  }}
                  key={value}
                  role="listitem"
                  onClick={handleToggle(value)}
                  disabled={
                    disabled[key] ||
                    (lockedAggregation && lockedAggregation !== value)
                  }
                >
                  <ListItemIcon
                    sx={{
                      "& .MuiListItemIcon-root	": {
                        width: "15px",
                      },
                    }}
                  >
                    <Checkbox
                      sx={{
                        width: "15px",
                        padding: 0,
                        margin: 0,
                        color: "#008CD7",
                        "& .MuiSvgIcon-root": {
                          fontSize: "20px",
                          color: "#008CD7",
                          fill: "#008CD7",
                        },
                      }}
                      icon={
                        <LK_CheckboxUnchecked
                          color="#008CD7"
                          width="13px"
                          height="13px"
                        />
                      }
                      checkedIcon={
                        <LK_CheckboxChecked
                          color="#008CD7"
                          width="13px"
                          height="13px"
                        />
                      }
                      checked={checked.includes(value)}
                      tabIndex={-1}
                      disableRipple
                      inputProps={{
                        "aria-labelledby": labelId,
                      }}
                    />
                  </ListItemIcon>
                  <ListItemText
                    sx={{ margin: "0px" }}
                    id={labelId}
                    primary={value}
                  />
                </ListItemButton>
              );
            })}
          </List>
        </Card>
      );

      const customTreeList = (title, items) => {
        return (
          <Card
            sx={{
              width: "40%",
              height: "680px",
              borderRadius: "0px",
              boxShadow: "none",
              backgroundColor: theme === "dark" ? "#efefef" : "#FFFFFF",
              border: "1px solid #E0E0E0",
              display: "flex",
              flexDirection: "row",
              // overflowY: "auto"
            }}
          >
            {/* <CardHeader
          sx={{ px: 2, py: 1 }}
          subheader={
            <Box>
              <Box>
                <Input
                  onChange={(e) => setSearchText(e.target.value)}
                  addonAfter={<CloseOutlined />}
                  placeholder="Search devices and tags..."
                  style={{ borderRadius: "4px" }}
                />
              </Box>
            </Box>
          }
        /> */}

            <Box
              sx={{
                width: "100%",
                height: "100%",
                overflow: "auto",
                padding: "8px",
                backgroundColor: theme === "dark" ? "#efefef" : "#FFFFFF",
              }}
            >
              <Tree
                checkable={false}
                onExpand={onExpand}
                expandedKeys={expandedKeys}
                autoExpandParent={autoExpandParent}
                showIcon
                switcherIcon={({ expanded }) => (
                  <ExpandMoreOutlinedIcon
                    sx={{
                      height: "20px",
                      width: "20px",
                      transform: expanded ? "rotate(0deg)" : "rotate(-90deg)",
                      transition: "transform 0.3s ease",
                      backgroundColor: "transparent",
                    }}
                  />
                )}
                checkedKeys={checkedKeys}
                onSelect={setSelectedKeys}
                selectedKeys={selectedKeys}
                treeData={renderTreeNodes(items)}
              />
            </Box>
          </Card>
        );
      };

      const options = [
        {
          label: "Tag",
          value: "name",
        },
        {
          label: "Alias",
          value: "alias",
        },
      ];

      const dataModeOptions = [
        {
          label: "Live",
          value: "live",
        },
        {
          label: "Historical",
          value: "historical",
        },
      ];

      const onDataModeChange = ({ target: { value } }) => {
        // Check if there are already selected tags
        if (right.length > 0) {
          const firstTag = right[0];
          const parts = firstTag.split("~");
          const existingIsLive = parts[parts.length - 1] === "LIVE";

          // Prevent switching if tags of opposite mode exist
          if (
            (existingIsLive && value === "historical") ||
            (!existingIsLive && value === "live")
          ) {
            showToast(
              "Warning",
              `Cannot switch to ${value} mode. Remove existing ${existingIsLive ? "Live" : "Historical"} tags first.`,
              "Warning",
            );
            return;
          }
        }

        setDataMode(value);
        // setChecked([]);
        // setDisabled([true, true, true, true, true, true, true]);
      };

      if (!openTagSelectionPopup) return null;

      return (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor:
              theme === "dark" ? "rgba(255,255,255,0.7)" : "rgba(0,0,0,0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1300,
          }}
          onClick={handleCloseTagSelectionPopup}
        >
          <Box
            sx={{
              width: "85%", // Reduced from 95% to 85%
              maxWidth: "1200px", // Added max width for better control
              height: "85%", // Reduced from 90% to 85%
              backgroundColor: "#FFFFFF",
              borderRadius: "0px", // Increased border radius
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)", // Enhanced shadow
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            {/* <Box
          sx={{
            padding: '20px 24px',
            background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)', // Changed to subtle gradient
            color: '#FFFFFF',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        > */}
            {/* Header */}
            <Box
              sx={{
                padding: "20px 24px",
                backgroundColor: theme === "dark" ? "#000000" : "#EFEFEF", // White background
                color: "#008CD7", // Blue text
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #E0E0E0", // Add subtle border
              }}
            >
              <Typography
                sx={{
                  color: theme === "dark" ? "#FFFFFF" : "#5B5B5B",
                  fontSize: "22px", // Slightly smaller
                  fontWeight: 600,
                  margin: 0,
                }}
              >
                Tag Selection
              </Typography>
              <Box sx={{ display: "flex", gap: 2 }}>
                <CustomCancelButton
                  onClick={handleCloseTagSelectionPopup}
                  buttonText="Cancel"
                  style={{
                    backgroundColor: "#F5F5F5", // Light grey background
                    border: "1px solid #005C8E",
                    color: "#005C8E", // Blue text
                  }}
                />
                <CustomButton
                  onClick={handleSaveTagSelection}
                  buttonText="Save Selection"
                  style={{
                    backgroundColor: "#005C8E",
                    color: "#FFFFFF",
                    fontWeight: 600,
                  }}
                  sx={{ borderRadius: "20px" }}
                />
              </Box>
            </Box>

            {/* Content */}
            <Box
              sx={{
                padding: "16px", // Increased padding
                flex: 1,
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
                backgroundColor: theme === "dark" ? "#000000" : "#EFEFEF", // Light background
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-around",
                  backgroundColor: theme === "dark" ? "#000000" : "#EFEFEF",
                  gap: "16px", // Increased gap
                  height: "100%",
                }}
              >
                {customTreeList("Options", left)}

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column-reverse",
                    gap: "12px", // Increased gap
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {/* Show aggregation options only in historical mode */}
                  {dataMode === "historical" && customListAgg(center)}

                  <Box
                    sx={{
                      display: "flex",
                      gap: "12px", // Increased gap
                      justifyContent: "center",
                    }}
                  >
                    <CustomButton
                      buttonText=">"
                      onClick={handleCheckedRightTree}
                      disabled={
                        checkedKeys.length === 0 ||
                        (dataMode === "historical" && centerChecked.length === 0)
                      }
                      style={{
                        minWidth: "45px",
                        height: "35px",
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                      sx={{
                        borderRadius: "12px",
                      }}
                    />
                    <CustomButton
                      buttonText="<"
                      onClick={handleCheckedLeftTree}
                      disabled={rightChecked.length === 0}
                      style={{
                        minWidth: "45px",
                        height: "35px",
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                      sx={{
                        borderRadius: "12px",
                      }}
                    />
                  </Box>

                  {/* Live/Historical radio buttons */}
                  <Box
                    sx={{
                      marginBottom: "8px",
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px", // Increased gap
                      alignItems: "center",
                      backgroundColor: "#ffffff",
                      padding: "12px",
                      borderRadius: "8px",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <Radio.Group
                      options={dataModeOptions}
                      onChange={onDataModeChange}
                      value={dataMode}
                      optionType="button"
                      buttonStyle="solid"
                    />
                    {/* <Radio.Group
                  options={options}
                  onChange={onChange3}
                  value={value3}
                  optionType="button"
                  buttonStyle="solid"
                /> */}
                  </Box>
                </Box>

                {customList("Selected Tags", right, true)}
              </Box>
            </Box>
          </Box>
        </Box>
      );
    })();
  }, [
    openTagSelectionPopup,
    left,
    right,
    center,
    checked,
    checkedKeys,
    value3,
    dataMode,
    searchText,
    disabled,
    expandedKeys,
    selectedKeys,
    autoExpandParent,
    lockedAggregation,
    theme,
    handleCloseTagSelectionPopup,
    handleToggle,
    handleToggleRight,
    onExpand,
    setSearchText,
    setCheckedKeys,
    setDisabled,
    setSelectedKeys,
    setDataMode,
    setChecked,
    renderTreeNodes,
    selectedTagType,
    projectId,
  ]);
  const IconSelectionSection = () => {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          flexDirection: "column",
          width: "100%",
        }}
      >
        {console.log("Icon Data:", { iconBase64, iconHeight, iconWidth })}
        <Typography
          style={{
            marginBottom: "10px",
            marginTop: "10px",
            fontSize: "16px",
            fontWeight: 400,
            color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
          }}
        >
          Icon Selection
        </Typography>

        <Box style={{ display: "flex", gap: "50px", alignItems: "center" }}>
          <Box
            sx={{
              height: "100px",
              width: "100px",
              border: "2px solid #008CD7",
              borderRadius: "50%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundImage: `url(${backgroundimg})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center center",
              backgroundSize: `${iconWidth || imagewidth}px ${iconHeight || imageheight}px`,
              cursor: "pointer",
            }}
            onClick={handleLogoClick}
          >
            <input
              style={{ display: "none" }}
              ref={inputFile}
              onChange={handleImageUpload}
              type="file"
              accept=".png,.PNG,.jpg,.jpeg,.gif"
              multiple={false}
            />
            <AddIcon
              style={{
                width: "40px",
                height: "40px",
                color: backgroundimg === "" ? "#008CD7" : "transparent",
                cursor: "pointer",
              }}
            />
          </Box>

          <Box>
            <Box style={{ display: "flex", flexDirection: "column" }}>
              <TextField
                label="Height"
                variant="standard"
                type="number"
                InputProps={{
                  inputProps: { min: 20, max: 40 },
                }}
                sx={{
                  width: "80px",
                  marginBottom: "10px",
                  "& .MuiInputLabel-root": {
                    color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: "var(--PrimaryText)",
                  },
                }}
                value={iconHeight || ""}
                onChange={(e) =>
                  handleLogoDimensionChange("height", e.target.value)
                }
                error={!!logoErrors.logoHeight}
                helperText={logoErrors.logoHeight}
                FormHelperTextProps={{
                  sx: {
                    color: "#DC272D",
                    fontSize: "12px",
                  },
                }}
              />

              <TextField
                label="Width"
                variant="standard"
                type="number"
                InputProps={{
                  inputProps: { min: 20, max: 40 },
                }}
                sx={{
                  width: "80px",
                  marginBottom: "20px",
                  "& .MuiInputLabel-root": {
                    color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: "var(--PrimaryText)",
                  },
                }}
                value={iconWidth || ""}
                onChange={(e) =>
                  handleLogoDimensionChange("width", e.target.value)
                }
                error={!!logoErrors.logoWidth}
                helperText={logoErrors.logoWidth}
                FormHelperTextProps={{
                  sx: {
                    color: "#DC272D",
                    fontSize: "12px",
                  },
                }}
              />
            </Box>
          </Box>
        </Box>

        <Typography
          style={{
            fontSize: "12px",
            color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
            marginTop: "5px",
          }}
        >
          Allowed formats: PNG, JPG, JPEG, GIF (Max Height & Width: 70px)
        </Typography>
      </Box>
    );
  };
  // Device and Tag Selection Component
  const DeviceTagSelection = () => {
    if (!parameterType || parameterType !== "tag") return null;

    return (
      <>
        {/* Tag Selection Button */}
        <Box
          className="config-form-box"
          sx={{
            padding: "4px 4px 4px 0px",
            width: "33.33%",
            boxSizing: "border-box",
            marginTop: "12px",
          }}
        >
          <Typography
            style={{
              fontSize: "16px",
              fontWeight: 400,
              color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
              width: "224px",
              marginBottom: "8px",
            }}
          >
            Tag Selection
          </Typography>
          <CustomButton
            onClick={handleOpenTagSelectionPopup}
            buttonText="Select Tags"
            style={{
              width: "224px",
              height: "35px",
            }}
            sx={{ borderRadius: "20px" }}
          />
        </Box>

        {/* Display Selected Tags Count */}
        {console.log("selectedTags", selectedTags)}
        {selectedTags && selectedTags.length > 0 && (
          <Box
            className="config-form-box"
            sx={{
              padding: "4px 4px 4px 0px",
              width: "100%",
              boxSizing: "border-box",
              marginTop: "12px",
            }}
          >
            <Typography
              style={{
                fontSize: "16px",
                fontWeight: 600,
                color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                marginBottom: "12px",
              }}
            >
              Selected Tags: ({selectedTags.length})
            </Typography>

            <Box
              sx={{
                maxHeight: "100px",
                overflowY: "auto",
                border: "2px solid #008CD7",
                borderRadius: "4px",
                padding: "8px",
                backgroundColor: theme === "light" ? "#e3f2fd" : "#1e3a5f",
              }}
            >
              {selectedTags.slice(0, 5).map((tag, index) => {
                const parts = tag.split("~");
                const displayText =
                  parts.length > 7
                    ? `${parts[1]}:${parts[2]}:${parts[3]}`
                    : `${parts[1]}:${parts[2]}`;
                return (
                  <Typography
                    key={index}
                    variant="body2"
                    sx={{
                      color: "#008CD7",
                      marginBottom: "4px",
                    }}
                  >
                    • {displayText}
                  </Typography>
                );
              })}
              {selectedTags.length > 5 && (
                <Typography
                  variant="body2"
                  sx={{
                    color: "#008CD7",
                    fontStyle: "italic",
                  }}
                >
                  ... and {selectedTags.length - 5} more
                </Typography>
              )}
            </Box>
          </Box>
        )}

        {/* Time Period */}
        <Box
          className="config-form-box"
          sx={{
            padding: "4px 4px 4px 0px",
            width: "33.33%",
            boxSizing: "border-box",
            marginTop: "12px",
            minHeight: selectedTags.some((tag) => tag.includes("~LIVE"))
              ? "100px"
              : "auto",
          }}
        >
          <Typography
            style={{
              fontSize: "16px",
              fontWeight: 400,
              color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
              width: "224px",
            }}
          >
            Time Period
          </Typography>
          {console.log("Time Period:", timePeriod)}
          <CustomDropDown
            options={timePeriodOptions}
            onChange={(value) => handleParameterChange("timePeriod", value)}
            defaultValue={timePeriod}
            width={224}
            disabled={selectedTags.some((tag) => tag.includes("~LIVE"))}
          />
        </Box>

        <Box
          className="config-form-box"
          sx={{
            padding: "4px 4px 4px 0px",
            width: "33.33%",
            boxSizing: "border-box",
            marginTop: "12px",
          }}
        >
          {selectedTags.some((tag) => tag.includes("~LIVE")) && (
            <Typography
              style={{
                fontSize: "11px",
                fontWeight: 400,
                color: "#DC272D",
                width: "220px",
                marginTop: "8px",
                lineHeight: "1.3",
                display: "block",
              }}
            >
              Time Period is not applicable for Live tags
            </Typography>
          )}
        </Box>

        {/* Unit Selection */}
        <Box
          className="config-form-box"
          sx={{
            padding: "4px 4px 4px 0px",
            width: "33.33%",
            boxSizing: "border-box",
            marginTop: "12px",
          }}
        >
          <Typography
            style={{
              fontSize: "16px",
              fontWeight: 400,
              color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
              width: "224px",
            }}
          >
            Unit Selection
          </Typography>
          <CustomDropDown
            options={unitOptions}
            onChange={(value) => handleParameterChange("unitSelection", value)}
            defaultValue={unitSelection}
            width={224}
          />
        </Box>

        {/* Icon Selection */}

        <Box
          className="config-form-box"
          sx={{
            padding: "4px 4px 4px 0px",
            width: "100%", // Changed to 100% to accommodate the full section
            boxSizing: "border-box",
            marginTop: "12px",
          }}
        >
          <LogoSelectionSection />
        </Box>
      </>
    );
  };

  // Parameter Form component - Memoized to prevent recreation on every render
  const ParameterForm = useMemo(() => {
    // Use individual states instead of currentParameter object

    return (
      <Box
        sx={{
          width: "100%",
          height: "100%",
          padding: "8px", // Add left padding   // Add right padding
          boxSizing: "border-box",
        }}
      >
        {/* <Box
          sx={{
            width: '100%',
            height: '7%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mb: 2
          }}
        >
          <Typography 
            style={{ fontSize: '24px', fontWeight: 700, color: '#008CD7' }}
          >
            {isEditMode ? `Edit: ${parameter.name}` : 'Add Parameter'}
          </Typography> */}
        <Box
          sx={{
            width: "98%",
            height: "7%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 2,
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography
              style={{
                fontSize: "24px",
                fontWeight: 700,
                color: "#008CD7",
                textAlign: "left",
                marginTop: "20px",
              }}
            >
              {isEditMode ? `Edit: ${paramName}` : "Add Parameter"}
            </Typography>
            {/* Add subscript note only when adding new parameter */}
            {!isEditMode && (
              <div style={{ justifyContent: "left", textAlign: "left" }}>
                <Typography
                  sx={{
                    fontSize: "15px",
                    fontStyle: "italic",
                    color: theme === "dark" ? "#A0A0A0" : "#666666",
                    marginTop: "2px",
                  }}
                >
                  * Maximum {MAX_PARAMETERS} parameters can be created
                </Typography>
                <Typography
                  sx={{
                    fontSize: "15px",
                    fontStyle: "italic",
                    color: theme === "dark" ? "#A0A0A0" : "#666666",
                    marginTop: "2px",
                  }}
                >
                  * When you select 'Target' or 'Yearly Baseline' the values
                  configured in 'General' section configuration will be
                  considered irrespective of Parameter Type
                </Typography>
              </div>
            )}
          </Box>
        </Box>

        <Box
          sx={{
            width: "100%",
            height: "93%",
            overflow: "auto",
          }}
        >
          {/* Parameter Details Section */}
          <Typography
            className="config-heading"
            style={{
              fontSize: "20px",
              fontWeight: 400,
              color: "#008CD7",
              padding: "4px",
              marginTop: "20px",
            }}
          >
            Parameter Details
            <Button
              onClick={() => {
                deviceDetails === 1 ? setDeviceDetails(0) : setDeviceDetails(1);
              }}
            >
              {deviceDetails === 1 ? (
                <ExpandLessOutlinedIcon
                  style={{
                    width: "28px",
                    height: "28px",
                    fontWeight: 700,
                    color: "#008CD7",
                  }}
                />
              ) : (
                <ExpandMoreOutlinedIcon
                  style={{
                    width: "28px",
                    height: "28px",
                    fontWeight: 700,
                    color: "#008CD7",
                  }}
                />
              )}
            </Button>
          </Typography>

          {deviceDetails === 1 ? (
            <Box
              style={{ overflow: "auto" }}
              sx={{
                display: "flex",
                gap: "0px",
                flexWrap: "wrap",
                padding: "4px 4px 12px 4px",
                backgroundColor: theme === "dark" ? "#3C3C3C40" : "#FFFFFF80",
              }}
            >
              <Box
                className="config-form-box"
                sx={{
                  padding: "4px 4px 4px 0px",
                  width: "33.33%",
                  boxSizing: "border-box",
                  marginTop: "12px",
                }}
              >
                <Typography
                  style={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                    width: "224px",
                  }}
                >
                  Parameter Name
                  <span style={{ color: "red", marginLeft: "5px" }}>*</span>
                </Typography>
                <CustomTextFieldWithErrorProps
                  id="parameter-name"
                  onChange={handleParameterName}
                  disabled={isEditMode === true}
                  value={paramName}
                  maxLength={25}
                  width={224}
                  error={!!validationErrors.paramName}
                  helperText={
                    validationErrors.paramName
                      ? `${validationErrors.paramName} ${paramName.length}/25 characters used`
                      : `${paramName.length}/25 characters used`
                  }
                  FormHelperTextProps={{
                    sx: {
                      color: validationErrors.paramName ? "#DC272D" : "#00943D",
                      maxWidth: "224px",
                      minHeight: "40px",
                    },
                  }}
                />
              </Box>

              <Box
                className="config-form-box"
                sx={{
                  padding: "4px 4px 4px 0px",
                  width: "50%",
                  boxSizing: "border-box",
                  marginTop: "12px",
                }}
              >
                <Typography
                  style={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                    width: "224px",
                  }}
                >
                  Parameter Type
                  <span style={{ color: "red", marginLeft: "5px" }}>*</span>
                </Typography>
                {console.log("parameter type here", parameterType)}
                <CustomDropDown
                  options={["tag", "manual"]}
                  onChange={(value) => {
                    handleParameterChange("parameterType", value);
                    // Reset device and tag selection when parameter type changes
                    if (value !== "tag") {
                      setSelectedDeviceId("");
                      setSelectedTagId("");
                      handleParameterChange("deviceId", "");
                      handleParameterChange("tagSelection", "");
                    }
                  }}
                  defaultValue={parameterType}
                  width={224}
                />
              </Box>

              {/* Device and Tag Selection - only show for 'tag' parameter type */}
              <DeviceTagSelection />

              {parameterType === "target" && (
                <>
                  <Box
                    className="config-form-box"
                    sx={{
                      padding: "4px 4px 4px 0px",
                      width: "33.33%",
                      boxSizing: "border-box",
                      marginTop: "12px",
                    }}
                  >
                    <Box
                      className="config-form-box"
                      style={{ gap: 0, marginTop: 0 }}
                    >
                      <br></br>
                      <CustomCheckbox
                        style={{ Padding: 0 }}
                        defaultValue={targetYearlyBaseline}
                        onChange={handleYearlyBaseline}
                      ></CustomCheckbox>
                      <Typography
                        style={{
                          fontSize: "16px",
                          fontWeight: 400,
                          color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                          width: "224px",
                          marginLeft: "8px",
                        }}
                      >
                        Yearly Baseline
                      </Typography>
                    </Box>
                  </Box>

                  <Box
                    className="config-form-box"
                    sx={{
                      padding: "4px 4px 4px 0px",
                      width: "33.33%",
                      boxSizing: "border-box",
                      marginTop: "12px",
                    }}
                  >
                    <Box
                      className="config-form-box"
                      style={{ gap: 0, marginTop: 0 }}
                    >
                      <CustomCheckbox
                        style={{ Padding: 0 }}
                        defaultValue={targetTarget}
                        onChange={handleTarget}
                      ></CustomCheckbox>
                      <Typography
                        style={{
                          fontSize: "16px",
                          fontWeight: 400,
                          color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                          width: "224px",
                          marginLeft: "8px",
                        }}
                      >
                        Target
                      </Typography>
                    </Box>
                  </Box>

                  <Box
                    className="config-form-box"
                    sx={{
                      padding: "4px 4px 4px 0px",
                      width: "33.33%",
                      boxSizing: "border-box",
                      marginTop: "12px",
                    }}
                  >
                    <Typography
                      style={{
                        fontSize: "16px",
                        fontWeight: 400,
                        color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                        width: "224px",
                      }}
                    >
                      Manual Value
                    </Typography>
                    <CustomTextFieldWithErrorProps
                      id="manual-target-value"
                      onChange={(value) => {
                        handleParameterChange(
                          "targetSelection.manualValue",
                          value,
                        );
                        handleManualValue(value);
                      }}
                      value={targetManualValue}
                      width={224}
                      type="number"
                      inputProps={{ min: 0, max: 999999, step: 0.01 }}
                      error={!!validationErrors.manualValue}
                      helperText={validationErrors.manualValue}
                      FormHelperTextProps={{
                        sx: {
                          color: validationErrors.manualValue
                            ? "#DC272D"
                            : "#00943D",
                          maxWidth: "224px",
                          minHeight: "40px",
                        },
                      }}
                    />
                  </Box>

                  <Box
                    className="config-form-box"
                    sx={{
                      padding: "4px 4px 4px 0px",
                      width: "33.33%",
                      boxSizing: "border-box",
                      marginTop: "12px",
                    }}
                  >
                    <Typography
                      style={{
                        fontSize: "16px",
                        fontWeight: 400,
                        color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                        width: "224px",
                      }}
                    >
                      Manual Unit
                    </Typography>
                    <CustomTextFieldWithErrorProps
                      id="manual-target-unit"
                      onChange={handleManualUnit}
                      value={targetManualUnit}
                      maxLength={10}
                      width={224}
                      error={!!validationErrors.manualUnit}
                      helperText={
                        validationErrors.manualUnit
                          ? `${validationErrors.manualUnit} ${targetManualUnit.length}/10 characters used`
                          : `${targetManualUnit.length}/10 characters used`
                      }
                      FormHelperTextProps={{
                        sx: {
                          color: validationErrors.manualUnit
                            ? "#DC272D"
                            : "#00943D",
                          maxWidth: "224px",
                          minHeight: "40px",
                        },
                      }}
                    />
                  </Box>

                  <Box
                    className="config-form-box"
                    sx={{
                      padding: "4px 4px 4px 0px",
                      width: "33.33%",
                      boxSizing: "border-box",
                      marginTop: "12px",
                    }}
                  >
                    <Typography
                      style={{
                        fontSize: "16px",
                        fontWeight: 400,
                        color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                        width: "224px",
                      }}
                    >
                      Time Period
                    </Typography>
                    <CustomDropDown
                      options={timePeriodOptions}
                      onChange={(value) =>
                        handleParameterChange("timePeriod", value)
                      }
                      defaultValue={parameter.timePeriod}
                      width={224}
                    />
                  </Box>

                  <Box
                    className="config-form-box"
                    sx={{
                      padding: "4px 4px 4px 0px",
                      width: "33.33%",
                      boxSizing: "border-box",
                      marginTop: "12px",
                    }}
                  >
                    <Typography
                      style={{
                        fontSize: "16px",
                        fontWeight: 400,
                        color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                        width: "224px",
                      }}
                    >
                      Unit Selection
                    </Typography>
                    <CustomDropDown
                      options={unitOptions}
                      onChange={(value) =>
                        handleParameterChange("unitSelection", value)
                      }
                      defaultValue={parameter.unitSelection}
                      width={224}
                    />
                  </Box>

                  <Box
                    className="config-form-box"
                    sx={{
                      padding: "4px 4px 4px 0px",
                      width: "33.33%",
                      boxSizing: "border-box",
                      marginTop: "12px",
                    }}
                  >
                    <Typography
                      style={{
                        fontSize: "16px",
                        fontWeight: 400,
                        color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                        width: "224px",
                      }}
                    >
                      Icon Selection
                    </Typography>
                    <CustomUploadButton defaultValue={iconPath} />
                  </Box>

                  <Box
                    className="config-form-box"
                    sx={{
                      padding: "4px 4px 4px 0px",
                      width: "33.33%",
                      boxSizing: "border-box",
                      marginTop: "12px",
                    }}
                  >
                    <Typography
                      style={{
                        fontSize: "16px",
                        fontWeight: 400,
                        color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                        width: "224px",
                      }}
                    >
                      <Typography
                        variant="caption"
                        sx={{
                          display: "block",
                          color: theme === "dark" ? "#aaa" : "#666",
                          fontStyle: "italic",
                        }}
                      ></Typography>
                    </Typography>
                  </Box>
                </>
              )}

              {parameterType === "manual" && (
                <>
                  <Box
                    className="config-form-box"
                    sx={{
                      padding: "4px 4px 4px 0px",
                      width: "33.33%",
                      boxSizing: "border-box",
                      marginTop: "12px",
                    }}
                  >
                    <Typography
                      style={{
                        fontSize: "16px",
                        fontWeight: 400,
                        color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                        width: "224px",
                      }}
                    >
                      Value
                    </Typography>
                    <CustomTextFieldWithErrorProps
                      id="manual-value"
                      onChange={(value) => {
                        handleParameterChange(
                          "targetSelection.manualValue",
                          value,
                        );
                        handleManualValue(value);
                      }}
                      value={targetManualValue}
                      width={224}
                      type="number"
                      inputProps={{ min: 0, max: 999999, step: 0.01 }}
                      error={!!validationErrors.manualValue}
                      helperText={validationErrors.manualValue}
                      FormHelperTextProps={{
                        sx: {
                          color: validationErrors.manualValue
                            ? "#DC272D"
                            : "#00943D",
                          maxWidth: "224px",
                          minHeight: "40px",
                        },
                      }}
                    />
                  </Box>

                  <Box
                    className="config-form-box"
                    sx={{
                      padding: "4px 4px 4px 0px",
                      width: "33.33%",
                      boxSizing: "border-box",
                      marginTop: "12px",
                    }}
                  >
                    <Typography
                      style={{
                        fontSize: "16px",
                        fontWeight: 400,
                        color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                        width: "224px",
                      }}
                    >
                      Unit
                    </Typography>
                    <CustomTextFieldWithErrorProps
                      id="manual-unit"
                      onChange={handleManualUnit}
                      value={targetManualUnit}
                      maxLength={10}
                      width={224}
                      error={!!validationErrors.manualUnit}
                      helperText={
                        validationErrors.manualUnit
                          ? `${validationErrors.manualUnit} ${targetManualUnit.length}/10 characters used`
                          : `${targetManualUnit.length}/10 characters used`
                      }
                      FormHelperTextProps={{
                        sx: {
                          color: validationErrors.manualUnit
                            ? "#DC272D"
                            : "#00943D",
                          maxWidth: "224px",
                          minHeight: "40px",
                        },
                      }}
                    />
                  </Box>

                  <Box
                    className="config-form-box"
                    sx={{
                      padding: "4px 4px 4px 0px",
                      width: "33.33%",
                      boxSizing: "border-box",
                      marginTop: "12px",
                    }}
                  >
                    <Typography
                      style={{
                        fontSize: "16px",
                        fontWeight: 400,
                        color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                        width: "224px",
                      }}
                    >
                      Time Period
                    </Typography>
                    <CustomDropDown
                      options={timePeriodOptions}
                      onChange={(value) =>
                        handleParameterChange("timePeriod", value)
                      }
                      defaultValue={parameter.timePeriod}
                      width={224}
                      disabled={true}
                    />
                  </Box>

                  <Box
                    className="config-form-box"
                    sx={{
                      padding: "4px 4px 4px 0px",
                      width: "33.33%",
                      boxSizing: "border-box",
                      marginTop: "12px",
                    }}
                  >
                    <Typography
                      style={{
                        fontSize: "16px",
                        fontWeight: 400,
                        color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                        width: "224px",
                      }}
                    >
                      Unit Selection
                    </Typography>
                    <CustomDropDown
                      options={unitOptions}
                      onChange={(value) =>
                        handleParameterChange("unitSelection", value)
                      }
                      defaultValue={parameter.unitSelection}
                      width={224}
                      disabled={true}
                    />
                  </Box>
                  <Box
                    className="config-form-box"
                    sx={{
                      padding: "4px 4px 4px 0px",
                      width: "100%", // Full width for the icon section
                      boxSizing: "border-box",
                      marginTop: "12px",
                    }}
                  >
                    <IconSelectionSection />
                  </Box>

                  <Box
                    className="config-form-box"
                    sx={{
                      padding: "4px 4px 4px 0px",
                      width: "33.33%",
                      boxSizing: "border-box",
                      marginTop: "12px",
                    }}
                  >
                    <Typography
                      style={{
                        fontSize: "16px",
                        fontWeight: 400,
                        color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                        width: "224px",
                      }}
                    >
                      <Typography
                        variant="caption"
                        sx={{
                          display: "block",
                          color: theme === "dark" ? "#aaa" : "#666",
                          fontStyle: "italic",
                        }}
                      ></Typography>
                    </Typography>
                  </Box>
                </>
              )}
            </Box>
          ) : null}

          {/* Display Settings Section */}
          <Typography
            className="config-heading"
            style={{
              fontSize: "20px",
              fontWeight: 400,
              color: "#008CD7",
              padding: "4px",
              marginTop: "20px",
            }}
          >
            Display Settings
            <Button
              onClick={() => {
                displaySettings === 1
                  ? setDisplaySettings(0)
                  : setDisplaySettings(1);
              }}
            >
              {displaySettings === 1 ? (
                <ExpandLessOutlinedIcon
                  style={{
                    width: "28px",
                    height: "28px",
                    fontWeight: 700,
                    color: "#008CD7",
                  }}
                />
              ) : (
                <ExpandMoreOutlinedIcon
                  style={{
                    width: "28px",
                    height: "28px",
                    fontWeight: 700,
                    color: "#008CD7",
                  }}
                />
              )}
            </Button>
          </Typography>

          {displaySettings === 1 ? (
            <Box
              style={{ overflow: "auto" }}
              sx={{
                display: "flex",
                gap: "0px",
                flexWrap: "wrap",
                padding: "4px 4px 12px 4px",
                backgroundColor: theme === "dark" ? "#3C3C3C40" : "#FFFFFF80",
              }}
            >
              <Box
                className="config-form-box"
                sx={{
                  padding: "4px 4px 4px 0px",
                  width: "100%",
                  boxSizing: "border-box",
                  marginTop: "12px",
                }}
              >
                <Box
                  className="config-form-box"
                  style={{ gap: 0, marginTop: 0 }}
                >
                  {console.log(
                    "Rendering checkbox for showInCollapsedMode",
                    showInCollapsedMode,
                    "showAsCriticalParameter",
                    showAsCriticalParameter,
                  )}
                  <CustomCheckbox
                    style={{ Padding: 0 }}
                    /*defaultValue={showInCollapsedMode}*/
                    checked={showInCollapsedMode}
                    onChange={handleShowInCollapsedMode}
                  ></CustomCheckbox>
                  <Typography
                    style={{
                      fontSize: "16px",
                      fontWeight: 400,
                      color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                      width: "300px", // Increased width
                      marginLeft: "8px",
                      whiteSpace: "nowrap", // Prevents text wrapping,
                    }}
                  >
                    Enable to show in collapsed mode
                  </Typography>
                </Box>
              </Box>

              <Box
                className="config-form-box"
                sx={{
                  padding: "4px 4px 4px 0px",
                  width: "100%",
                  boxSizing: "border-box",
                  marginTop: "12px",
                }}
              >
                <Box
                  className="config-form-box"
                  style={{ gap: 0, marginTop: 0 }}
                >
                  <CustomCheckbox
                    style={{ Padding: 0 }}
                    /*defaultValue={showAsCriticalParameter}*/
                    checked={showAsCriticalParameter}
                    onChange={handleShowAsCriticalParameter}
                  ></CustomCheckbox>
                  <Typography
                    style={{
                      fontSize: "16px",
                      fontWeight: 400,
                      color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                      width: "300px", // Increased width
                      marginLeft: "8px",
                      whiteSpace: "nowrap", // Prevents text wrapping
                    }}
                  >
                    Enable to show as critical parameter
                  </Typography>
                </Box>
              </Box>
              <Box
                className="config-form-box"
                sx={{
                  padding: "4px 4px 4px 0px",
                  width: "100%",
                  boxSizing: "border-box",
                  marginTop: "12px",
                }}
              ></Box>
            </Box>
          ) : null}

          <Typography
            className="config-heading"
            style={{
              fontSize: "20px",
              fontWeight: 400,
              color: "#008CD7",
              padding: "4px",
              marginTop: "20px",
            }}
          >
            Plant Details
            <Button
              onClick={() => {
                plantDetails === 1 ? setPlantDetails(0) : setPlantDetails(1);
              }}
            >
              {plantDetails === 1 ? (
                <ExpandLessOutlinedIcon
                  style={{
                    width: "28px",
                    height: "28px",
                    fontWeight: 700,
                    color: "#008CD7",
                  }}
                />
              ) : (
                <ExpandMoreOutlinedIcon
                  style={{
                    width: "28px",
                    height: "28px",
                    fontWeight: 700,
                    color: "#008CD7",
                  }}
                />
              )}
            </Button>
          </Typography>

          {plantDetails === 1 ? (
            <Box
              style={{ overflow: "auto" }}
              sx={{
                display: "flex",
                gap: "0px",
                flexWrap: "wrap",
                padding: "12px",
                backgroundColor: theme === "dark" ? "#3C3C3C40" : "#FFFFFF80",
              }}
            >
              {/* Client Section */}
              {/* Client Section with Organization Name/Custom Input on the right */}
              {/* Client Section with Text Field on Left, Radio Buttons on Right */}
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  gap: "16px",
                  marginTop: "12px",
                  alignItems: "flex-start",
                }}
              >
                {/* Client Text Field - Left Side */}
                <Box
                  className="config-form-box"
                  sx={{
                    padding: "4px 4px 4px 0px",
                    width: "60%",
                    boxSizing: "border-box",
                  }}
                >
                  <Typography
                    style={{
                      fontSize: "16px",
                      fontWeight: 400,
                      color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                      marginBottom: "8px",
                    }}
                  >
                    Client Name
                  </Typography>
                  {/* <TextField
      variant="outlined"
      fullWidth
      value={
        parameter.plantDetails.clientType === 'organization' 
          ? (organizationData?.Organizationname || 'Not Available')
          : (parameter.plantDetails.clientValue || '')
      }
      onChange={handleClientValueCallback}
      disabled={parameter.plantDetails.clientType === 'organization'}
      placeholder={parameter.plantDetails.clientType === 'custom' ? "Enter client name" : ""}
      sx={{
        width: "100%",
        "& .MuiOutlinedInput-root": {
          backgroundColor: parameter.plantDetails.clientType === 'organization' 
            ? (theme === "dark" ? "#2C2C2C" : "#F5F5F5")
            : (theme === "dark" ? "#3C3C3C" : "#FFFFFF"),
          "& fieldset": {
            borderColor: "#008CD7",
          },
          "&:hover fieldset": {
            borderColor: "#006BA6",
          },
          "&.Mui-focused fieldset": {
            borderColor: "#008CD7",
          },
        },
        "& .MuiInputBase-input": {
          color: theme === "dark" ? "#FFFFFF" : "#3C3C3C",
          fontSize: "14px",
        },
        "& .MuiInputBase-input.Mui-disabled": {
          color: theme === "dark" ? "#C1C1C1" : "#666666",
          "-webkit-text-fill-color": theme === "dark" ? "#C1C1C1" : "#666666",
        }
      }}
    /> */}
                  <TextField
                    variant="standard"
                    fullWidth
                    value={
                      plantClientType === "organization"
                        ? organizationData?.Organizationname || "Not Available"
                        : plantClientValue || ""
                    }
                    onChange={handleClientValueCallback}
                    disabled={plantClientType === "organization"}
                    placeholder={
                      plantClientType === "custom" ? "Enter client name" : ""
                    }
                    inputProps={{ minLength: 3, maxLength: 50 }}
                    sx={{
                      width: "40%",
                      "& .MuiInput-underline:before": {
                        borderBottomColor: "#000000",
                        borderBottomWidth: "0.5px", // Thinner black line
                      },
                      "& .MuiInput-underline:hover:before": {
                        borderBottomColor: "#000000",
                        borderBottomWidth: "0.5px",
                      },
                      "& .MuiInput-underline:after": {
                        borderBottomColor: "#000000",
                        borderBottomWidth: "0.5px",
                      },
                      // Add this for disabled state to maintain same underline
                      "& .MuiInput-underline.Mui-disabled:before": {
                        borderBottomColor: "#000000",
                        borderBottomWidth: "0.5px",
                        borderBottomStyle: "solid", // Ensure solid line even when disabled
                      },
                      "& .MuiInputBase-input": {
                        color: theme === "dark" ? "#FFFFFF" : "#3C3C3C",
                        fontSize: "14px",
                      },
                      "& .MuiInputBase-input.Mui-disabled": {
                        color: theme === "dark" ? "#C1C1C1" : "#666666",
                        "-webkit-text-fill-color":
                          theme === "dark" ? "#C1C1C1" : "#666666",
                      },
                    }}
                    error={
                      plantClientType === "custom" &&
                      !!validationErrors.clientValue
                    }
                    helperText={
                      plantClientType === "custom" &&
                      validationErrors.clientValue
                        ? `${validationErrors.clientValue} ${plantClientValue.length}/50 characters used`
                        : plantClientType === "custom"
                          ? `${plantClientValue.length}/50 characters used`
                          : ""
                    }
                    FormHelperTextProps={{
                      sx: {
                        color: validationErrors.clientValue
                          ? "#DC272D"
                          : "#00943D",
                        maxWidth: "300px",
                        minHeight: "40px",
                      },
                    }}
                  />
                </Box>

                {/* Radio Buttons - Right Side */}
                <Box
                  className="config-form-box"
                  sx={{
                    padding: "4px 4px 4px 0px",
                    width: "40%",
                    boxSizing: "border-box",
                  }}
                >
                  <Typography
                    style={{
                      fontSize: "16px",
                      fontWeight: 400,
                      color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                      marginBottom: "8px",
                    }}
                  >
                    Client Source
                  </Typography>
                  <Radio.Group
                    value={plantClientType}
                    onChange={handleClientTypeCallback}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    <Radio
                      value="organization"
                      style={{
                        color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                        marginBottom: "8px",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 400,
                          color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                        }}
                      >
                        Use Organization Name
                      </Typography>
                    </Radio>
                    <Radio
                      value="custom"
                      style={{
                        color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 400,
                          color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                        }}
                      >
                        Custom
                      </Typography>
                    </Radio>
                  </Radio.Group>
                </Box>
              </Box>

              {/* Project Section with dynamic right side */}
              {/* Project Section with Text Field on Left, Dropdown in Middle (conditional), Radio Buttons on Right */}
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  gap: "12px",
                  marginTop: "12px",
                  alignItems: "flex-start",
                }}
              >
                {/* Project Text Field - Left Side */}
                <Box
                  className="config-form-box"
                  sx={{
                    padding: "4px 4px 4px 0px",
                    width: plantProjectType === "projectDetail" ? "35%" : "60%",
                    boxSizing: "border-box",
                  }}
                >
                  <Typography
                    style={{
                      fontSize: "16px",
                      fontWeight: 400,
                      color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                      marginBottom: "8px",
                    }}
                  >
                    Project Name
                  </Typography>
                  <TextField
                    variant="standard"
                    fullWidth
                    value={getProjectTextFieldValue()}
                    onChange={handleProjectValue}
                    disabled={plantProjectType !== "custom"}
                    placeholder={
                      plantProjectType === "custom" ? "Enter project name" : ""
                    }
                    inputProps={{ minLength: 3, maxLength: 50 }}
                    sx={{
                      width: "40%",
                      "& .MuiInput-underline:before": {
                        borderBottomColor: "#000000",
                        borderBottomWidth: "0.5px", // Thinner black line
                      },
                      "& .MuiInput-underline:hover:before": {
                        borderBottomColor: "#000000",
                        borderBottomWidth: "0.5px",
                      },
                      "& .MuiInput-underline:after": {
                        borderBottomColor: "#000000",
                        borderBottomWidth: "0.5px",
                      },
                      // Add this for disabled state to maintain same underline
                      "& .MuiInput-underline.Mui-disabled:before": {
                        borderBottomColor: "#000000",
                        borderBottomWidth: "0.5px",
                        borderBottomStyle: "solid", // Ensure solid line even when disabled
                      },
                      "& .MuiInputBase-input": {
                        color: theme === "dark" ? "#FFFFFF" : "#3C3C3C",
                        fontSize: "14px",
                      },
                      "& .MuiInputBase-input.Mui-disabled": {
                        color: theme === "dark" ? "#C1C1C1" : "#666666",
                        "-webkit-text-fill-color":
                          theme === "dark" ? "#C1C1C1" : "#666666",
                      },
                    }}
                    error={
                      plantProjectType === "custom" &&
                      !!validationErrors.projectValue
                    }
                    helperText={
                      plantProjectType === "custom" &&
                      validationErrors.projectValue
                        ? `${validationErrors.projectValue} ${plantProjectValue.length}/50 characters used`
                        : plantProjectType === "custom"
                          ? `${plantProjectValue.length}/50 characters used`
                          : ""
                    }
                    FormHelperTextProps={{
                      sx: {
                        color: validationErrors.projectValue
                          ? "#DC272D"
                          : "#00943D",
                        maxWidth: "300px",
                        minHeight: "40px",
                      },
                    }}
                  />
                </Box>

                {/* Select Detail Dropdown - Middle (only show when projectDetail is selected) */}
                {plantProjectType === "projectDetail" && (
                  <Box
                    className="config-form-box"
                    sx={{
                      padding: "4px 4px 4px 0px",
                      width: "25%",
                      boxSizing: "border-box",
                    }}
                  >
                    <Typography
                      style={{
                        fontSize: "16px",
                        fontWeight: 400,
                        color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                        marginBottom: "8px",
                      }}
                    >
                      Select Detail
                    </Typography>
                    <CustomDropDown
                      options={[
                        "Country",
                        "State",
                        "Location",
                        "Pin",
                        "Latitude",
                        "Longitude",
                        "Region",
                      ]}
                      onChange={handleProjectDetailSelection}
                      defaultValue={plantSelectedProjectDetail || "Country"}
                      width="50%"
                    />
                  </Box>
                )}

                {/* Radio Buttons - Right Side */}
                <Box
                  className="config-form-box"
                  sx={{
                    padding: "4px 4px 4px 0px",
                    width: plantProjectType === "projectDetail" ? "40%" : "40%",
                    boxSizing: "border-box",
                  }}
                >
                  <Typography
                    style={{
                      fontSize: "16px",
                      fontWeight: 400,
                      color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                      marginBottom: "8px",
                    }}
                  >
                    Project Source
                  </Typography>
                  <Radio.Group
                    value={plantProjectType}
                    onChange={handleProjectType}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "4px",
                    }}
                  >
                    <Radio
                      value="project"
                      style={{
                        color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                        marginBottom: "4px",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "13px",
                          fontWeight: 400,
                          color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                        }}
                      >
                        Use Project Name
                      </Typography>
                    </Radio>
                    <Radio
                      value="projectDetail"
                      style={{
                        color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                        marginBottom: "4px",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "13px",
                          fontWeight: 400,
                          color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                        }}
                      >
                        Use Project Detail
                      </Typography>
                    </Radio>
                    <Radio
                      value="custom"
                      style={{
                        color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "13px",
                          fontWeight: 400,
                          color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                        }}
                      >
                        Custom
                      </Typography>
                    </Radio>
                  </Radio.Group>
                </Box>
              </Box>

              {/* Additional Field Section with dynamic right side */}
              {/* Additional Field Section with Text Field on Left, Dropdown in Middle (conditional), Radio Buttons on Right */}
              {/* Additional Field Section with Text Field on Left, Dropdown in Middle (conditional), Radio Buttons on Right */}
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  gap: "12px",
                  marginTop: "12px",
                  alignItems: "flex-start",
                }}
              >
                {/* Additional Field Text Field - Left Side */}
                <Box
                  className="config-form-box"
                  sx={{
                    padding: "4px 4px 4px 0px",
                    width:
                      plantCustomFieldType === "projectDetail" ? "35%" : "60%",
                    boxSizing: "border-box",
                  }}
                >
                  <Typography
                    style={{
                      fontSize: "16px",
                      fontWeight: 400,
                      color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                      marginBottom: "8px",
                    }}
                  >
                    Additional Field
                  </Typography>
                  <TextField
                    variant="standard"
                    fullWidth
                    value={getAdditionalFieldTextValue()}
                    onChange={
                      plantCustomFieldType === "custom"
                        ? handleCustomFieldValue
                        : undefined
                    }
                    disabled={plantCustomFieldType !== "custom"}
                    placeholder={
                      plantCustomFieldType === "custom"
                        ? "Enter custom field value"
                        : ""
                    }
                    inputProps={{ minLength: 1, maxLength: 50 }}
                    sx={{
                      width: "40%",
                      "& .MuiInput-underline:before": {
                        borderBottomColor: "#000000",
                        borderBottomWidth: "0.5px", // Thinner black line
                      },
                      "& .MuiInput-underline:hover:before": {
                        borderBottomColor: "#000000",
                        borderBottomWidth: "0.5px",
                      },
                      "& .MuiInput-underline:after": {
                        borderBottomColor: "#000000",
                        borderBottomWidth: "0.5px",
                      },
                      // Add this for disabled state to maintain same underline
                      "& .MuiInput-underline.Mui-disabled:before": {
                        borderBottomColor: "#000000",
                        borderBottomWidth: "0.5px",
                        borderBottomStyle: "solid", // Ensure solid line even when disabled
                      },
                      "& .MuiInputBase-input": {
                        color: theme === "dark" ? "#FFFFFF" : "#3C3C3C",
                        fontSize: "14px",
                      },
                      "& .MuiInputBase-input.Mui-disabled": {
                        color: theme === "dark" ? "#C1C1C1" : "#666666",
                        "-webkit-text-fill-color":
                          theme === "dark" ? "#C1C1C1" : "#666666",
                      },
                    }}
                    error={
                      plantCustomFieldType === "custom" &&
                      !!validationErrors.customFieldValue
                    }
                    helperText={
                      plantCustomFieldType === "custom" &&
                      validationErrors.customFieldValue
                        ? `${validationErrors.customFieldValue} ${plantCustomFieldValue.length}/50 characters used`
                        : plantCustomFieldType === "custom"
                          ? `${plantCustomFieldValue.length}/50 characters used`
                          : ""
                    }
                    FormHelperTextProps={{
                      sx: {
                        color: validationErrors.customFieldValue
                          ? "#DC272D"
                          : "#00943D",
                        maxWidth: "300px",
                        minHeight: "40px",
                      },
                    }}
                  />
                </Box>

                {/* Select Detail Dropdown - Middle (only show when projectDetail is selected) */}
                {plantCustomFieldType === "projectDetail" && (
                  <Box
                    className="config-form-box"
                    sx={{
                      padding: "4px 4px 4px 0px",
                      width: "25%",
                      boxSizing: "border-box",
                    }}
                  >
                    <Typography
                      style={{
                        fontSize: "16px",
                        fontWeight: 400,
                        color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                        marginBottom: "8px",
                      }}
                    >
                      Select Detail
                    </Typography>
                    <CustomDropDown
                      options={[
                        "Country",
                        "State",
                        "Location",
                        "Pin",
                        "Latitude",
                        "Longitude",
                        "Region",
                      ]}
                      onChange={handleAdditionalFieldDetailSelection}
                      defaultValue={
                        plantSelectedAdditionalFieldDetail || "Country"
                      }
                      width="100%"
                    />
                  </Box>
                )}

                {/* Radio Buttons - Right Side */}
                <Box
                  className="config-form-box"
                  sx={{
                    padding: "4px 4px 4px 0px",
                    width:
                      plantCustomFieldType === "projectDetail" ? "40%" : "40%",
                    boxSizing: "border-box",
                  }}
                >
                  <Typography
                    style={{
                      fontSize: "16px",
                      fontWeight: 400,
                      color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                      marginBottom: "8px",
                    }}
                  >
                    Field Source
                  </Typography>
                  <Radio.Group
                    value={plantCustomFieldType}
                    onChange={handleCustomFieldType}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "6px",
                    }}
                  >
                    <Radio
                      value="projectDetail"
                      style={{
                        color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                        marginBottom: "6px",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "13px",
                          fontWeight: 400,
                          color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                        }}
                      >
                        Use Project Detail
                      </Typography>
                    </Radio>
                    <Radio
                      value="custom"
                      style={{
                        color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "13px",
                          fontWeight: 400,
                          color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                        }}
                      >
                        Custom Field
                      </Typography>
                    </Radio>
                  </Radio.Group>
                </Box>
              </Box>
              {/* Icon Selection */}

              <Box
                className="config-form-box"
                sx={{
                  padding: "4px 4px 4px 0px",
                  width: "100%", // Changed to 100% to accommodate the full section
                  boxSizing: "border-box",
                  marginTop: "12px",
                }}
              >
                <PlantIconSelectionSection />
              </Box>
            </Box>
          ) : null}
        </Box>
      </Box> // 👈 This should STAY - closes the ParameterForm Box
    );
  }, [
    paramName,
    parameterType,
    selectedDevices,
    selectedTags,
    targetYearlyBaseline,
    targetTarget,
    targetManualValue,
    targetManualUnit,
    timePeriod,
    unitSelection,
    iconBase64,
    iconHeight,
    iconWidth,
    showInCollapsedMode,
    showAsCriticalParameter,
    deviceDetails,
    displaySettings,
    plantDetails,
    plantClientType,
    plantClientValue,
    plantProjectType,
    plantProjectValue,
    plantSelectedProjectDetail,
    plantCustomFieldType,
    plantSelectedAdditionalFieldDetail,
    plantCustomFieldName,
    plantCustomFieldValue,
    plantIconBase64,
    plantIconHeight,
    plantIconWidth,
    backgroundimg,
    plantBackgroundImg,
    logoErrors,
    plantLogoErrors,
    isEditMode,
    theme,
    organizationData,
    projectDataArray,
  ]);

  return (
    <Box sx={{ height: "100%", boxSizing: "border-box", width: "100%" }}>
      {/* Toast Message */}
      <CustomToast
        toastTitle={toast.title}
        toastText={toast.message}
        openToast={openToast}
        onClose={handleCloseToast}
        type={toast.type}
        width="500px"
      />

      {/* Always-visible save info message */}
      <Typography
        sx={{
          fontSize: "16px",
          fontWeight: 600,
          margin: "8px 0",
          color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
          textAlign: "center",
        }}
      >
        Click on Save to confirm Creation, Deletion or Editing of items.
      </Typography>

      <Box
        sx={{
          padding: "8px",
          height: "calc(100% - 0px)",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        {/* Header section with controls */}
        <Box
          sx={{
            padding: "0px",
            width: "100%",
            height: "6%",
            boxSizing: "border-box",
            justifyContent: "space-between", // 👈 ADD THIS
            alignItems: "center", // 👈 ADD THIS
            display: "flex",
          }}
        >
          {!openForm ? (
            <>
              <Box
                style={{ flexGrow: 1, height: "24px", alignSelf: "center" }}
              ></Box>

              {/* Display Button */}

              {/* Parameter Count Indicator - ADD THIS BEFORE THE BUTTON */}
              <Typography
                sx={{
                  fontSize: "12px",
                  fontWeight: 400,
                  color:
                    parameters.length >= MAX_PARAMETERS
                      ? "#DC272D"
                      : "var(--PrimaryText)",
                  alignSelf: "center",
                  marginRight: "8px",
                  whiteSpace: "nowrap",
                }}
              >
                {parameters.length}/{MAX_PARAMETERS} Parameters
              </Typography>

              {/* Updated Add Parameter Button */}
              <Button
                onClick={handleAddParameter}
                disabled={parameters.length >= MAX_PARAMETERS}
                sx={{
                  width: "40px",
                  "& .MuiButtonBase-root.MuiButton-root": { width: "40px" },
                  padding: 0,
                  opacity: parameters.length >= MAX_PARAMETERS ? 0.5 : 1,
                  cursor:
                    parameters.length >= MAX_PARAMETERS
                      ? "not-allowed"
                      : "pointer",
                }}
                style={{
                  fontSize: "12px",
                  height: "28px",
                  minWidth: "40px",
                  fontWeight: 400,
                  alignSelf: "center",
                }}
                title={
                  parameters.length >= MAX_PARAMETERS
                    ? `Maximum ${MAX_PARAMETERS} parameters allowed`
                    : "Add Parameter"
                }
              >
                {/* (userDetails.User_Role_Details && userDetails.User_Role_Details.Name && userDetails.User_Role_Details.Name != 'ORG_ANALYST') && */}
                {
                  <LK_Add
                    color={
                      parameters.length >= MAX_PARAMETERS
                        ? "var(--GreyBaseColor)"
                        : "var(--LK_BrandBlue)"
                    }
                    width={"28px"}
                    height={"28px"}
                  />
                }
              </Button>

              {console.log("Exported Parameters:", exportParameterArr)}
              {!deleteMode ? (
                <Button
                  onClick={handleEnterDeleteMode}
                  style={{
                    fontSize: "12px",
                    height: "28px",
                    minWidth: "36px",
                    fontWeight: 400,
                    alignSelf: "center",
                  }}
                >
                  {
                    <LK_Delete
                      color="var(--LK_BrandBlue)"
                      width={"36px"}
                      height={"36px"}
                    />
                  }
                </Button>
              ) : (
                <>
                  <Button
                    onClick={handleDeleteSelected}
                    style={{
                      fontSize: "12px",
                      height: "28px",
                      minWidth: "36px",
                      fontWeight: 400,
                      alignSelf: "center",
                    }}
                  >
                    {
                      <LK_Delete
                        color="var(--LK_BrandBlue)"
                        width={"36px"}
                        height={"36px"}
                      />
                    }
                  </Button>
                  <Button
                    onClick={handleExitDeleteMode}
                    style={{
                      fontSize: "12px",
                      height: "28px",
                      minWidth: "24px",
                      fontWeight: 400,
                      alignSelf: "center",
                      marginLeft: "-20px",
                      marginRight: "0",
                      marginTop: "-8px",
                    }}
                  >
                    {
                      <LK_Close
                        color="var(--LK_BrandBlue)"
                        width={"24px"}
                        height={"24px"}
                      />
                    }
                  </Button>
                </>
              )}

              {/* !exportMode ? (
                <div style={{display:"flex", flexDirection:"row"}}>
                    <div>
                        <Typography 
                          style={{
                            fontSize: "14px",
                            fontWeight: 400,
                            color: "var(--GreyBaseColor)",
                            textAlign: "center"
                          }}
                        >
                          Org Level Parameters
                        </Typography>
                    </div>
                    <Button
                      onClick={handleEnterExportMode}
                      style={{
                        fontSize: "12px",
                        height: "28px",
                        minWidth: "36px",
                        fontWeight: 400,
                        alignSelf: "center",
                      }}
                    >*/}
              {/* Use either your custom icon or Material-UI icon */}
              {/*
                      <UpgradeIcon
                        color="var(--LK_BrandBlue)"
                        width={"36px"}
                        height={"36px"}
                        sx={{marginRight:"25px"}}
                      />*/}
              {/* OR if you don't have UpgradeIcon, use this instead:
                      <FileDownloadIcon 
                        style={{ 
                          color: "var(--LK_BrandBlue)", 
                          fontSize: "20px" 
                        }} 
                      />
                      */}
              {/*
                    </Button>
                </div>
              ) : (
                <>
                  <div style={{display:"flex", flexDirection:"row"}}>
                    <div>
                        <Typography 
                          style={{
                            fontSize: "14px",
                            fontWeight: 400,
                            color: "var(--GreyBaseColor)",
                            textAlign: "center"
                          }}
                        >
                          Org Level Parameters
                        </Typography>
                    </div>
                    <Button
                      onClick={handleExportSelected}
                      style={{
                        fontSize: "12px",
                        height: "28px",
                        minWidth: "36px",
                        fontWeight: 400,
                        alignSelf: "center",
                      }}
                    >
                     {/* <UpgradeIcon
                        color="var(--LK_BrandBlue)"
                        width={"36px"}
                        height={"36px"}
                      /> */}
              {/* OR Material-UI alternative:
                      <FileDownloadIcon 
                        style={{ 
                          color: "var(--LK_BrandBlue)", 
                          fontSize: "20px" 
                        }} 
                      />
                      */}
              {/*
                    </Button>
                  </div>
                  <Button
                    onClick={handleExitExportMode}
                    style={{
                      fontSize: "12px",
                      height: "28px",
                      minWidth: "24px",
                      fontWeight: 400,
                      alignSelf: "center",
                      marginLeft: "-20px",
                      marginRight: "0",
                      marginTop: "-8px",
                    }}
                  >
                    <LK_Close
                      color="var(--LK_BrandBlue)"
                      width={"24px"}
                      height={"24px"}
                    />
                  </Button>
                </>
              ) */}

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  width: "auto",
                  fontSize: "16px",
                  fontFamily: "Roboto",
                  alignSelf: "center",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <CustomTextFieldNew
                  id="search-parameters"
                  onChange={handleSearchChange}
                  value={searchQuery}
                  placeholder="Search parameters..."
                  width={180}
                />
                <Button
                  style={{
                    fontSize: "12px",
                    minWidth: "28px",
                    fontWeight: 400,
                    color: "var(--Searchtext_muted)",
                    fontFamily: "Roboto",
                    textAlign: "left",
                    justifySelf: "right",
                    cursor: "pointer",
                    textTransform: "none",
                  }}
                >
                  <LK_Search
                    color="var(--LK_BrandBlue)"
                    width={"28px"}
                    height={"28px"}
                  />
                </Button>

                {searchQuery && (
                  <Button
                    onClick={() => setSearchQuery("")}
                    style={{
                      fontSize: "12px",
                      width: "10px",
                      fontWeight: 400,
                      color: "var(--Searchtext_muted)",
                      fontFamily: "Roboto",
                      textAlign: "left",
                      justifySelf: "right",
                      cursor: "pointer",
                      textTransform: "none",
                      marginLeft: "-44px",
                      padding: 0,
                    }}
                  >
                    <LK_Close
                      color="var(--LK_BrandBlue)"
                      width={"24px"}
                      height={"24px"}
                    />
                  </Button>
                )}
                <CustomButton
                  onClick={handleSaveOverviewConfig}
                  buttonText={"Save"}
                  disabled={isLoading}
                />
              </Box>
            </>
          ) : (
            // ADD THIS NEW SECTION FOR FORM STATE (LIKE GATEWAY):
            <Box
              sx={{
                display: "flex",
                gap: "20px",
                width: "100%",
                height: "100%",
              }}
            >
              <Box sx={{ flexGrow: 1 }}></Box>
              {required && (
                <Typography sx={{ color: "#DC272D", alignSelf: "center" }}>
                  Required fields must be filled
                </Typography>
              )}
              {saveStatus !== 0 && (
                <Typography
                  sx={{
                    color:
                      saveStatus === 1
                        ? theme === "dark"
                          ? "#C1C1C1"
                          : "#3C3C3C"
                        : "#DC272D",
                    alignSelf: "center",
                  }}
                >
                  {saveStatus === 1 ? "Saved Successfully!" : "Save Failed"}
                </Typography>
              )}
              <CustomCancelButton
                onClick={handleCloseForm}
                buttonText={"Cancel"}
                disabled={isLoading}
              />
              <CustomButton
                onClick={handleSaveForm}
                buttonText={"Confirm"}
                disabled={isLoading}
              />
            </Box>
          )}
        </Box>

        {/* Main content area */}
        <Box
          sx={{
            boxSizing: "border-box",
            padding: "0px",
            background: "var(--PrimaryBackground)",
            height: "calc(94%)",
            marginBottom: "0px",
            width: "100%",
            // overflow: "auto",
          }}
        >
          {openForm ? (
            ParameterForm
          ) : isLoading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <CircularProgress sx={{ color: "#008CD7" }} />
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                gap: "8px",
                //flexWrap: "wrap",
                flexDirection: "column",
                boxSizing: "border-box",
                height: "calc(100%)",
                overflow: "auto",
                //alignContent: "flex-start",
                width: "100%",
              }}
            >
              {console.log(
                "filteredParameters:in CONFIG OVERVIEWBAR",
                filteredParameters,
              )}
              {filteredParameters.length > 0 ? (
                // <ParameterTable
                //   parameters={filteredParameters
                //     .filter(param => param.isDisplayed !== false)
                //     .sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0))
                //   }
                <>
                  <ParameterTable
                    parameters={filteredParameters
                      .filter((param) => param.isDisplayed !== false)
                      .sort((a, b) => {
                        // Define priority groups
                        const getPriorityGroup = (param) => {
                          if (
                            param.SelectedParameter &&
                            !param.showAsCriticalParameter
                          )
                            return 1; // Selected only
                          if (
                            param.SelectedParameter &&
                            param.showAsCriticalParameter
                          )
                            return 2; // Both Selected and Critical
                          return 3; // Regular parameters
                        };

                        const aPriority = getPriorityGroup(a);
                        const bPriority = getPriorityGroup(b);

                        // Sort by priority groups first
                        if (aPriority !== bPriority) {
                          return aPriority - bPriority;
                        }

                        // Within same priority group, sort by display order
                        return (a.displayOrder || 0) - (b.displayOrder || 0);
                      })}
                    onReorder={(newParameters) => {
                      // Create priority groups for reordering logic
                      const priorityGroups = {
                        selectedOnly: [],
                        selectedAndCritical: [],
                        regular: [],
                      };

                      // Separate parameters into priority groups
                      newParameters.forEach((param) => {
                        if (
                          param.SelectedParameter &&
                          !param.showAsCriticalParameter
                        ) {
                          priorityGroups.selectedOnly.push(param);
                        } else if (
                          param.SelectedParameter &&
                          param.showAsCriticalParameter
                        ) {
                          priorityGroups.selectedAndCritical.push(param);
                        } else {
                          priorityGroups.regular.push(param);
                        }
                      });

                      // Assign display orders within each priority group
                      let displayOrderCounter = 0;

                      const updatedParameters = newParameters.map((param) => {
                        let groupIndex;

                        if (
                          param.SelectedParameter &&
                          !param.showAsCriticalParameter
                        ) {
                          groupIndex =
                            priorityGroups.selectedOnly.indexOf(param);
                        } else if (
                          param.SelectedParameter &&
                          param.showAsCriticalParameter
                        ) {
                          groupIndex =
                            priorityGroups.selectedAndCritical.indexOf(param);
                        } else {
                          groupIndex = priorityGroups.regular.indexOf(param);
                        }

                        return {
                          ...param,
                          displayOrder: displayOrderCounter++,
                        };
                      });

                      const success = saveParameters(updatedParameters);
                      if (success) {
                        setParameters(updatedParameters);
                        setFilteredParameters(updatedParameters);
                      }
                    }}
                    onEdit={handleEditParameter}
                    deleteMode={deleteMode}
                    onDeleteCheck={handleDeleteCheck}
                    deleteParameterArr={deleteParameterArr}
                    showAdditionalSelect={exportMode}
                    additionalSelectTitle="Select for Export"
                    additionalSelectArr={exportParameterArr}
                    onAdditionalSelectCheck={handleExportCheck}
                    theme={theme}
                    getDeviceName={getDeviceName}
                    getTagName={getTagName}
                    getParameterBackgroundColor={getParameterBackgroundColor}
                  />
                  {console.log(
                    "filteredParametersOVERIEWCONFIG",
                    filteredParameters,
                  )}
                </>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    height: "200px",
                  }}
                >
                  <Typography
                    style={{
                      fontSize: "24px",
                      fontWeight: 700,
                      color: "var(--GreyBaseColor)",
                      textAlign: "center",
                      marginBottom: "8px", // 👈 ADD THIS
                    }}
                  >
                    {searchQuery
                      ? "No Match Found"
                      : "No Parameters Configured"}
                  </Typography>
                  {!searchQuery && ( // 👈 ADD THIS ENTIRE BLOCK
                    <Typography
                      style={{
                        fontSize: "14px",
                        fontWeight: 400,
                        color: "var(--GreyBaseColor)",
                        textAlign: "center",
                      }}
                    >
                      You can create up to {MAX_PARAMETERS} parameters
                    </Typography>
                  )}
                  {/* <Typography 
                      style={{
                        fontSize: "24px",
                        fontWeight: 700,
                        color: "var(--GreyBaseColor)",
                        textAlign: "center"
                      }}
                    >
                      {searchQuery ? 'No Match Found' : 'No Parameters Configured'}
                    </Typography> */}
                </Box>
              )}
            </Box>
          )}
        </Box>
      </Box>

      {/* Tag Selection Popup */}
      {TagSelectionPopup}

      {/* Display Configuration Popup */}
      <DisplayConfigPopup />

      <CustomDialogBox
        dialogTitle="Org Level Parameters"
        dialogText={`${exportParameterArr.length} selected parameter(s) to show at Org Level?`}
        openDialog={showExportDialog}
        handleCloseDialog={() => setShowExportDialog(false)}
        handleConfirmDialog={confirmExportParameter}
        confirmText="Confirm"
        cancelText="Cancel"
        type="Info"
      />
      {/* Confirmation Dialog */}
      <CustomDialogBox
        dialogTitle={dialogContent.title}
        dialogText={dialogContent.message}
        openDialog={showDialogDelete}
        handleCloseDialog={() => setShowDialogDelete(false)}
        handleConfirmDialog={confirmDeleteParameter}
        confirmText="Delete"
        cancelText="Cancel"
        type="Warning"
      />
      <CustomDialogBox
        dialogTitle={"Saved Configuration Successfully"}
        dialogText={createdSucessMsg}
        openDialog={createdSucess}
        handleCloseDialog={handleCloseCreateDashboard}
        handleConfirmDialog={handleCloseCreateDashboard}
        confirmText={"Ok"}
        cancelText={"Cancel"}
        type={"Success"}
      />
      <CustomDialogBox
        dialogTitle={"Created Overview Configuration Failed"}
        dialogText={notCreatedSuccessMsg}
        openDialog={notCreatedSuccess}
        handleCloseDialog={handleCloseNotCreateDashboard}
        handleConfirmDialog={handleCloseNotCreateDashboard}
        confirmText={"Ok"}
        cancelText={"Cancel"}
        type={"Error"}
      />
    </Box>
  );
};

export default OverviewConfig;
